(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["detail"] && !Shopify.designMode) return;
  try {
    
(() => {
 if (window.__reindeerDetails1) { window.__reindeerDetails1.boot(); return; }
 const selector='[data-reindeer-details]', initialized=new WeakSet();
 const observer='IntersectionObserver' in window ? new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.dataset.visible='true';observer.unobserve(entry.target)}}),{threshold:.1}):null;
 function select(root,index,announce=true){
  const panels=Array.from(root.querySelectorAll('[data-dt-panel]'));if(!panels.length)return;
  index=Math.max(0,Math.min(panels.length-1,Number(index)||0));const active=panels[index];
  panels.forEach((panel,i)=>panel.hidden=i!==index);
  root.querySelectorAll('[data-dt-tab]').forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1});
  root.querySelectorAll('[data-dt-scene]').forEach(scene=>scene.hidden=scene.dataset.dtScene!==active.dataset.dtSceneKey);
  root.querySelectorAll('[data-dt-pin]').forEach(pin=>{pin.hidden=pin.dataset.dtSceneKey!==active.dataset.dtSceneKey;pin.setAttribute('aria-pressed',String(Number(pin.dataset.dtPin)===index))});
  root.querySelector('[data-dt-view]').textContent=active.dataset.dtViewLabel;
  root.dataset.activeDetail=String(index);
  if(announce)root.querySelector('[data-dt-status]').textContent=`${index+1} / ${panels.length}: ${active.querySelector('h3').textContent}`;
 }
 function boot(){document.querySelectorAll(selector).forEach(root=>{if(initialized.has(root))return;initialized.add(root);if(!root.querySelector('[data-dt-panel]'))return;root.querySelectorAll('[data-dt-tab],[data-dt-pin]').forEach(button=>button.disabled=false);select(root,root.dataset.start,false);root.dataset.ready='true';if(observer&&root.dataset.motion==='true'&&root.dataset.reveal==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches){root.dataset.observed='true';observer.observe(root)}else root.dataset.visible='true'})}
 document.addEventListener('click',event=>{const button=event.target.closest?.('[data-dt-tab],[data-dt-pin]');const root=button?.closest(selector);if(root){event.preventDefault();select(root,button.dataset.dtTab??button.dataset.dtPin)}});
 document.addEventListener('keydown',event=>{const tab=event.target.closest?.('[data-dt-tab]'),root=tab?.closest(selector);if(!root)return;const tabs=Array.from(root.querySelectorAll('[data-dt-tab]')),index=tabs.indexOf(tab);let next;if(event.key==='ArrowRight')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();select(root,next);tabs[next].focus({preventScroll:true})});
 document.addEventListener('shopify:section:load',boot);
 document.addEventListener('shopify:block:select',event=>{const id=String(event.detail?.blockId||'');if(!id)return;document.querySelectorAll(selector).forEach(root=>{const panel=Array.from(root.querySelectorAll('[data-dt-block]')).find(node=>node.dataset.dtBlock===id);if(panel)select(root,panel.dataset.dtPanel,false)})});
 document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll?.(selector).forEach(root=>observer?.unobserve(root)));
 window.__reindeerDetails1={boot};boot();if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lambocolelction"] && !Shopify.designMode) return;
  try {
    
(() => {
 'use strict';
 if (window.__driveMistCollection1) { window.__driveMistCollection1.boot(); return; }
 const selector = '[data-drivemist-collection]', states = new Map();
 const reduced = root => root.dataset.motion !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
 function init(root) {
  if (states.has(root)) return;
  const abort = new AbortController(), panels = Array.from(root.querySelectorAll('[data-dmc-panel]'));
  const tabs = Array.from(root.querySelectorAll('[data-dmc-model]'));
  const dialog = root.querySelector('[data-dmc-dialog]');
  let model = Math.max(0, Math.min(panels.length - 1, Number(root.dataset.startModel) || 0));
  let finish = ['gold','purple','silver'].includes(root.dataset.startFinish) ? root.dataset.startFinish : 'gold';
  let trigger = null, observer = null;
  const on = (el,name,fn,options={}) => el?.addEventListener(name,fn,{...options,signal:abort.signal});
  function scene(panel) { return Array.from(panel?.querySelectorAll('[data-dmc-scene]') || []).find(item => item.dataset.dmcScene === finish) || panel?.querySelector('[data-dmc-scene]'); }
  function zoomState(panel) {
   const active = scene(panel), image = active?.querySelector('img'), button = panel.querySelector('[data-dmc-zoom]');
   if (button) button.hidden = !(image && !image.closest('picture').hidden && active.dataset.dmcZoomSrc);
  }
  function update(announce=true) {
   const activePanel = panels[model];
   const choices = Array.from(activePanel?.querySelectorAll('[data-dmc-finish]') || []);
   const matching = choices.find(input => input.value === finish || input.dataset.dmcFinishKey === finish);
   finish = matching?.value || activePanel?.dataset.dmcStartFinish || choices[0]?.value || 'default';
   panels.forEach((panel,i) => {
    panel.hidden = i !== model;
    const panelInputs = Array.from(panel.querySelectorAll('[data-dmc-finish]'));
    const panelFinish = panelInputs.find(input => input.value === finish)?.value || panel.dataset.dmcStartFinish || 'default';
    panel.querySelectorAll('[data-dmc-scene]').forEach(s => s.hidden = s.dataset.dmcScene !== panelFinish);
    panelInputs.forEach(input => input.checked = input.value === panelFinish);
    zoomState(panel);
   });
   tabs.forEach((tab,i) => { tab.setAttribute('aria-selected',String(i===model)); tab.tabIndex = i===model ? 0 : -1; });
   root.dataset.activeModel = String(model); root.dataset.activeFinish = finish;
   const status = root.querySelector('[data-dmc-status]');
   if (announce && status && panels[model]) status.textContent = `${panels[model].dataset.dmcTitle} · ${scene(panels[model])?.dataset.dmcFinishLabel || ''}`;
  }
  function choose(index,focus=false) {
   if (!panels.length) return;
   model = Math.max(0,Math.min(panels.length-1,Number(index)||0)); root.dataset.interacted='true'; update();
   if (focus) tabs[model]?.focus({preventScroll:true});
  }
  function destroy() {
   if (dialog?.open) dialog.close();
   abort.abort(); observer?.disconnect(); states.delete(root);
   delete root.dataset.ready; delete root.dataset.observed; delete root.dataset.interacted;
   root.querySelectorAll('[data-dmc-model],[data-dmc-finish]').forEach(el=>el.disabled=true);
   root.querySelectorAll('[data-dmc-zoom]').forEach(el=>el.hidden=true);
  }
  states.set(root,{destroy,choose,reveal:()=>root.dataset.visible='true'});
  root.querySelectorAll('[data-dmc-model],[data-dmc-finish]').forEach(el=>el.disabled=false);
  root.dataset.ready = 'true'; update(false);
  root.querySelectorAll('[data-dmc-scene] img').forEach(image => {
   const fail = () => { const current=image.closest('[data-dmc-scene]'); image.closest('picture').hidden=true; current.querySelector('[data-dmc-fallback]').hidden=false; zoomState(image.closest('[data-dmc-panel]')); };
   on(image,'error',fail);
   if (image.complete && !image.naturalWidth) fail();
  });
  const rect=root.getBoundingClientRect();
  if ('IntersectionObserver' in window && !reduced(root) && root.dataset.reveal==='true' && rect.top>=innerHeight) {
   root.dataset.observed='true';
   observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){root.dataset.visible='true';observer.disconnect();}},{threshold:.02});
   observer.observe(root);
  } else root.dataset.visible='true';
  on(root,'change',event=>{const input=event.target.closest('[data-dmc-finish]');if(input){finish=input.value;update();}});
  on(root,'keydown',event=>{
   const tab=event.target.closest('[data-dmc-model]');if(!tab)return;
   let next;const index=tabs.indexOf(tab);
   if(['ArrowRight','ArrowDown'].includes(event.key))next=(index+1)%tabs.length;
   else if(['ArrowLeft','ArrowUp'].includes(event.key))next=(index-1+tabs.length)%tabs.length;
   else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;
   event.preventDefault();choose(next,true);
  });
  on(root,'click',event=>{
   const tab=event.target.closest('[data-dmc-model]');if(tab)choose(tab.dataset.dmcModel);
   const zoom=event.target.closest('[data-dmc-zoom]');
   if(zoom && dialog && !dialog.open && typeof dialog.showModal==='function') {
    const active=scene(zoom.closest('[data-dmc-panel]')), image=active?.querySelector('img');
    const src=matchMedia('(max-width:989px)').matches ? active?.dataset.dmcZoomMobile || active?.dataset.dmcZoomSrc : active?.dataset.dmcZoomSrc;
    if(image && src && !image.closest('picture').hidden){
     const clone=image.cloneNode();['srcset','sizes','loading','id','style'].forEach(a=>clone.removeAttribute(a));clone.src=src;
     dialog.querySelector('[data-dmc-zoom-content]').replaceChildren(clone);trigger=zoom;dialog.showModal();
    }
   }
   if(event.target.closest('[data-dmc-close]'))dialog?.close();
   if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}
   const cta=event.target.closest('[data-dmc-cta]');
   if(!cta||root.dataset.autoCta!=='true'||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
   let target=null;const custom=(root.dataset.target||'').trim();
   if(custom){try{target=document.querySelector(custom);}catch{return;}}
   else {
    let candidates=Array.from(document.querySelectorAll('[data-drivemist-product],[data-salvation-root]'));
    candidates=candidates.filter(el=>!root.dataset.productId||!el.dataset.productId||el.dataset.productId===root.dataset.productId);
    target=candidates.filter(el=>el.compareDocumentPosition(root)&Node.DOCUMENT_POSITION_FOLLOWING).pop()||candidates[0];
   }
   if(!target)return;
   target=target.matches('.svb__offers')?target:target.querySelector('.svb__offers')||target;
   if(!target.getClientRects().length)return;
   event.preventDefault();
   window.scrollTo({top:Math.max(0,scrollY+target.getBoundingClientRect().top-Math.max(0,Number(root.dataset.offset)||0)),behavior:reduced(root)?'auto':'smooth'});
   const focus=target.matches('button,input,select,a')?target:target.querySelector('input[type="radio"]:checked:not(:disabled),[data-bundle-option]:not(:disabled),button:not(:disabled),select:not(:disabled)');
   focus?.focus({preventScroll:true});
  });
  on(dialog,'close',()=>{dialog.querySelector('[data-dmc-zoom-content]').replaceChildren();if(trigger?.isConnected)trigger.focus({preventScroll:true});});
 }
 function roots(target){return target?.matches?.(selector)?[target]:Array.from(target?.querySelectorAll?.(selector)||[]);}
 function boot(){states.forEach((state,root)=>{if(!root.isConnected)state.destroy();});document.querySelectorAll(selector).forEach(init);}
 document.addEventListener('shopify:section:load',boot);
 document.addEventListener('shopify:section:unload',event=>roots(event.target).forEach(root=>states.get(root)?.destroy()));
 document.addEventListener('shopify:section:select',event=>roots(event.target).forEach(root=>states.get(root)?.reveal()));
 document.addEventListener('shopify:block:select',event=>{boot();if(!event.detail?.blockId)return;document.querySelectorAll(selector).forEach(root=>{const panel=Array.from(root.querySelectorAll('[data-dmc-block]')).find(p=>p.dataset.dmcBlock===String(event.detail.blockId));if(panel){states.get(root)?.reveal();states.get(root)?.choose(panel.dataset.dmcPanel);}});});
 window.__driveMistCollection1={boot};boot();
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lambocustom"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('drivemist-customers')) {
  customElements.define('drivemist-customers', class extends HTMLElement {
    connectedCallback() {
      if (this.startFrame || this.controller) return;
      this.startFrame = requestAnimationFrame(() => {
        this.startFrame = null;
        if (this.isConnected) this.initialize();
      });
    }
    initialize() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.track = this.querySelector('[data-track]');
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.dialog = this.querySelector('[data-dialog]');
      this.largeImage = this.querySelector('[data-large-image]');
      this.pages = [];
      this.active = 0;
      this.addEventListener('click', event => {
        const target = event.target.closest('button');
        if (!target || !this.contains(target)) return;
        if (target.hasAttribute('data-prev')) this.go(this.active - 1);
        if (target.hasAttribute('data-next')) this.go(this.active + 1);
        if (target.hasAttribute('data-page')) this.go(Number(target.dataset.page));
        if (target.hasAttribute('data-close')) this.dialog?.close();
        if (target.hasAttribute('data-zoom')) this.openPhoto(target);
      }, { signal });
      if (this.dialog) {
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('close', () => {
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
          this.largeImage?.removeAttribute('src');
        }, { signal });
        this.largeImage?.addEventListener('error', () => {
          this.largeImage.hidden = true;
          this.querySelector('[data-image-error]').hidden = false;
        }, { signal });
      }
      if (!this.track) return;
      this.track.addEventListener('scroll', () => this.schedule(false), { passive: true, signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.active + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.active - 1); }
        if (event.key === 'Home') { event.preventDefault(); this.go(0); }
        if (event.key === 'End') { event.preventDefault(); this.go(this.pages.length - 1); }
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        if (event.detail?.sectionId !== this.id.replace('DriveMistCustomers-', '')) return;
        const card = this.cards.find(item => item.dataset.blockId === event.detail.blockId);
        if (card) this.track.scrollTo({ left: this.position(card), behavior: 'auto' });
      }, { signal });
      window.addEventListener('resize', () => this.schedule(true), { passive: true, signal });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.schedule(true));
        this.resizeObserver.observe(this.track);
      }
      this.schedule(true);
    }
    position(card) {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      return Math.max(0, Math.min(max, this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left - this.track.clientLeft));
    }
    schedule(rebuild) {
      this.needsRebuild = this.needsRebuild || rebuild;
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (!this.isConnected) return;
        this.update(this.needsRebuild);
        this.needsRebuild = false;
      });
    }
    update(rebuild) {
      if (rebuild) {
        this.pages = [];
        this.cards.forEach(card => {
          const left = this.position(card);
          if (!this.pages.some(page => Math.abs(page - left) < 3)) this.pages.push(left);
        });
        const dots = this.querySelector('[data-dots]');
        dots.replaceChildren(...this.pages.map((left, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'dmc__dot';
          button.dataset.page = String(index);
          button.setAttribute('aria-label', `${this.dataset.pageLabel} ${index + 1}`);
          button.setAttribute('aria-controls', this.track.id);
          return button;
        }));
      }
      this.active = this.pages.reduce((best, page, index) => Math.abs(page - this.track.scrollLeft) < Math.abs(this.pages[best] - this.track.scrollLeft) ? index : best, 0);
      this.querySelector('[data-controls]').hidden = this.pages.length < 2;
      this.querySelector('[data-prev]').disabled = this.track.scrollLeft <= 3;
      this.querySelector('[data-next]').disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 3;
      this.querySelectorAll('[data-page]').forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.active)));
    }
    go(index) {
      const left = this.pages[Math.max(0, Math.min(this.pages.length - 1, index))];
      if (left == null) return;
      this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    openPhoto(button) {
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.opener = button;
      this.largeImage.hidden = false;
      this.querySelector('[data-image-error]').hidden = true;
      this.largeImage.alt = button.dataset.alt || '';
      this.largeImage.src = button.dataset.src;
      if (!this.dialog.open) this.dialog.showModal();
    }
    disconnectedCallback() {
      if (this.startFrame) cancelAnimationFrame(this.startFrame);
      this.startFrame = null;
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.needsRebuild = false;
      if (this.dialog?.open) this.dialog.close();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lambodetail"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__driveMistDetails1) { window.__driveMistDetails1.boot(); return; }
  const selector = '[data-drivemist-details]';
  const states = new Map();
  const zoomTriggers = new WeakMap();
  const reduced = root => root.dataset.motion !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
  function rootsWithin(target) {
    return target?.matches?.(selector) ? [target] : Array.from(target?.querySelectorAll?.(selector) || []);
  }
  function select(root, value, announce = true) {
    const panels = Array.from(root.querySelectorAll('[data-dd-panel]'));
    if (!panels.length) return;
    const index = Math.max(0, Math.min(panels.length - 1, Number(value) || 0));
    const active = panels[index];
    panels.forEach((panel, i) => panel.hidden = i !== index);
    root.querySelectorAll('[data-dd-tab]').forEach((tab, i) => {
      tab.setAttribute('aria-selected', String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
    });
    root.querySelectorAll('[data-dd-scene]').forEach(scene => scene.hidden = scene.dataset.ddScene !== active.dataset.ddSceneKey);
    root.querySelectorAll('[data-dd-pin]').forEach(pin => {
      pin.hidden = pin.dataset.ddSceneKey !== active.dataset.ddSceneKey;
      pin.setAttribute('aria-pressed', String(Number(pin.dataset.ddPin) === index));
    });
    const label = root.querySelector('[data-dd-view]');
    if (label) label.textContent = active.dataset.ddViewLabel || '';
    root.dataset.activeDetail = String(index);
    const status = root.querySelector('[data-dd-status]');
    if (announce && status) status.textContent = `${index + 1} / ${panels.length}: ${active.querySelector('h3')?.textContent || ''}`;
  }
  function destroy(root) {
    states.get(root)?.observer?.disconnect();
    const dialog = root.querySelector('[data-dd-lightbox]');
    if (dialog?.open) dialog.close();
    states.delete(root);
    delete root.dataset.ready;
    delete root.dataset.observed;
    root.querySelectorAll('[data-dd-tab],[data-dd-pin]').forEach(button => button.disabled = true);
  }
  function boot() {
    states.forEach((state, root) => { if (!root.isConnected) destroy(root); });
    document.querySelectorAll(selector).forEach(root => {
      if (states.has(root)) return;
      const state = { observer: null };
      states.set(root, state);
      root.querySelectorAll('[data-dd-tab],[data-dd-pin]').forEach(button => button.disabled = false);
      select(root, root.dataset.start, false);
      root.dataset.ready = 'true';
      const rect = root.getBoundingClientRect();
      if ('IntersectionObserver' in window && !reduced(root) && root.dataset.reveal === 'true' && rect.top >= innerHeight) {
        root.dataset.observed = 'true';
        state.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            root.dataset.visible = 'true';
            state.observer.disconnect();
          }
        }, { threshold: 0.02 });
        state.observer.observe(root);
      } else root.dataset.visible = 'true';
    });
  }
  function productTarget(root) {
    const custom = (root.dataset.target || '').trim();
    if (custom) { try { const target = document.querySelector(custom); return target?.matches('.svb__offers') ? target : target?.querySelector('.svb__offers') || target; } catch { return null; } }
    let candidates = Array.from(document.querySelectorAll('[data-drivemist-product]'));
    if (!candidates.length) candidates = Array.from(document.querySelectorAll('[data-salvation-root]'));
    const productId = root.dataset.productId;
    if (productId) candidates = candidates.filter(node => !node.dataset.productId || node.dataset.productId === productId);
    const product = candidates.filter(node => node.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING).pop() || candidates[0];
    return product?.querySelector('.svb__offers') || product || null;
  }
  document.addEventListener('click', event => {
    const root = event.target.closest?.(selector);
    if (!root || !states.has(root)) return;
    const choice = event.target.closest('[data-dd-tab],[data-dd-pin]');
    if (choice) { event.preventDefault(); select(root, choice.dataset.ddTab ?? choice.dataset.ddPin); }
    const zoom = event.target.closest('[data-dd-zoom]');
    if (zoom) {
      const frame = zoom.closest('.dmd__closeup');
      const image = frame?.querySelector('img');
      const dialog = root.querySelector('[data-dd-lightbox]');
      const src = matchMedia('(max-width:989px)').matches && frame?.dataset.ddZoomMobile ? frame.dataset.ddZoomMobile : frame?.dataset.ddZoomSrc;
      if (image && src && dialog && !dialog.open && typeof dialog.showModal === 'function') {
        event.preventDefault();
        const clone = image.cloneNode();
        ['srcset', 'sizes', 'loading', 'id', 'style'].forEach(attr => clone.removeAttribute(attr));
        clone.src = src;
        dialog.querySelector('[data-dd-zoom-content]').replaceChildren(clone);
        zoomTriggers.set(dialog, zoom);
        dialog.showModal();
      }
    }
    if (event.target.closest('[data-dd-close]')) root.querySelector('[data-dd-lightbox]')?.close();
    if (event.target.matches('[data-dd-lightbox]')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
    const cta = event.target.closest('[data-dd-cta]');
    if (!cta || root.dataset.autoCta !== 'true' || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || event.button > 0) return;
    const target = productTarget(root);
    if (!target || !target.getClientRects().length) return;
    event.preventDefault();
    window.scrollTo({ top: Math.max(0, scrollY + target.getBoundingClientRect().top - Math.max(0, Number(root.dataset.offset) || 0)), behavior: reduced(root) ? 'auto' : 'smooth' });
    const focus = target.matches('input,button,a,select') ? target : target.querySelector('input[type="radio"]:checked:not(:disabled),[data-bundle-option]:not(:disabled),button:not(:disabled),select:not(:disabled)');
    focus?.focus({ preventScroll: true });
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest?.('[data-dd-tab]');
    const root = tab?.closest(selector);
    if (!root || !states.has(root)) return;
    const tabs = Array.from(root.querySelectorAll('[data-dd-tab]'));
    const index = tabs.indexOf(tab);
    let next;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    else return;
    event.preventDefault(); select(root, next); tabs[next].focus({ preventScroll: true });
  });
  document.addEventListener('close', event => {
    if (!event.target.matches?.('[data-dd-lightbox]')) return;
    const trigger = zoomTriggers.get(event.target);
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    event.target.querySelector('[data-dd-zoom-content]')?.replaceChildren();
  }, true);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', event => rootsWithin(event.target).forEach(destroy));
  document.addEventListener('shopify:section:select', event => rootsWithin(event.target).forEach(root => root.dataset.visible = 'true'));
  document.addEventListener('shopify:block:select', event => {
    const id = String(event.detail?.blockId || '');
    if (!id) return;
    boot();
    document.querySelectorAll(selector).forEach(root => {
      const panel = Array.from(root.querySelectorAll('[data-dd-block]')).find(node => node.dataset.ddBlock === id);
      if (panel) { root.dataset.visible = 'true'; select(root, panel.dataset.ddPanel, false); }
    });
  });
  window.__driveMistDetails1 = { boot };
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lambofaq"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__driveMistFAQ1) { window.__driveMistFAQ1.boot(); return; }
  const selector = '[data-drivemist-faq]', entries = new Map();
  const reduced = root => root.dataset.motion !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
  const query = (value, scope = document) => { try { return scope.querySelector(value); } catch { return null; } };
  const rootsInside = target => target?.matches?.(selector) ? [target] : Array.from(target?.querySelectorAll?.(selector) || []);
  function filter(entry, category, openFirst = false) {
    if (category !== 'all' && !entry.categories.has(category)) category = 'all';
    entry.category = category;
    entry.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.dmfFilter === category)));
    entry.items.forEach(item => {
      item.hidden = category !== 'all' && item.dataset.category !== category;
      if (item.hidden) item.open = false;
    });
    if (openFirst && entry.root.dataset.openFirst === 'true') {
      const first = entry.items.find(item => !item.hidden);
      if (first) first.open = true;
    }
  }
  function destroy(root) {
    const entry = entries.get(root); if (!entry) return;
    entry.abort.abort(); entry.reveal?.disconnect();
    entry.items.forEach(item => item.hidden = false);
    const controls = query('[data-dmf-filters]', root); if (controls) controls.hidden = true;
    root.querySelectorAll('[data-dmf-observed]').forEach(node => { node.removeAttribute('data-dmf-observed'); node.removeAttribute('data-dmf-visible'); });
    root.removeAttribute('data-dmf-ready'); entries.delete(root);
  }
  function boot() {
    for (const root of entries.keys()) if (!root.isConnected) destroy(root);
    document.querySelectorAll(selector).forEach(root => {
      if (entries.has(root)) return;
      const entry = { root, items: Array.from(root.querySelectorAll('[data-dmf-item]')), buttons: Array.from(root.querySelectorAll('[data-dmf-filter]')), categories: new Set(), abort: new AbortController(), reveal: null, category: 'all' };
      entry.items.forEach(item => entry.categories.add(item.dataset.category));
      entries.set(root, entry);
      entry.buttons.forEach(button => button.hidden = button.dataset.dmfFilter !== 'all' && !entry.categories.has(button.dataset.dmfFilter));
      const controls = query('[data-dmf-filters]', root); if (controls) controls.hidden = entry.categories.size < 2;
      filter(entry, 'all');
      entry.items.forEach(item => item.addEventListener('toggle', () => {
        if (!item.open || root.dataset.single !== 'true') return;
        entry.items.forEach(other => { if (other !== item) other.open = false; });
      }, { signal: entry.abort.signal }));
      if ('IntersectionObserver' in window && !reduced(root) && root.dataset.reveal === 'true') {
        entry.reveal = new IntersectionObserver(items => items.forEach(item => {
          if (item.isIntersecting) { item.target.setAttribute('data-dmf-visible', ''); entry.reveal.unobserve(item.target); }
        }), { threshold: 0.02, rootMargin: '0px 0px 80px 0px' });
        root.querySelectorAll('[data-dmf-reveal]').forEach(node => {
          const rect = node.getBoundingClientRect();
          if (rect.top < innerHeight && rect.bottom > 0) node.setAttribute('data-dmf-visible', '');
          else { node.setAttribute('data-dmf-observed', ''); entry.reveal.observe(node); }
        });
      }
      root.setAttribute('data-dmf-ready', '');
    });
  }
  function productTarget(root) {
    if ((root.dataset.target || '').trim()) {
      const target = query(root.dataset.target);
      return target?.matches('.svb__offers') ? target : target?.querySelector('.svb__offers') || target;
    }
    let products = Array.from(document.querySelectorAll('[data-drivemist-product]'));
    if (!products.length) products = Array.from(document.querySelectorAll('[data-salvation-root]'));
    if (root.dataset.productId) products = products.filter(product => !product.dataset.productId || product.dataset.productId === root.dataset.productId);
    const previous = products.filter(product => product.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING);
    const product = previous.at(-1) || products[0];
    return product?.querySelector('.svb__offers') || product || null;
  }
  function guideTarget(root) {
    let guides = Array.from(document.querySelectorAll('[data-drivemist-collection]'));
    if (root.dataset.productId) guides = guides.filter(guide => guide.dataset.productId === root.dataset.productId);
    const previous = guides.filter(guide => guide.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING);
    return previous.at(-1) || guides[0] || null;
  }
  function scrollToTarget(root, target, isProduct) {
    window.scrollTo({ top: Math.max(0, scrollY + target.getBoundingClientRect().top - Math.max(0,Number(root.dataset.offset)||0)), behavior: reduced(root) ? 'auto' : 'smooth' });
    if (isProduct) {
      const control = target.matches('input,button,a,select') ? target : query('input[type="radio"]:checked:not(:disabled),[data-bundle-option]:not(:disabled),[data-atc]:not(:disabled)', target);
      control?.focus({ preventScroll: true });
    } else {
      const heading = query('h2', target);
      if (heading) { if (!heading.hasAttribute('tabindex')) heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
    }
  }
  document.addEventListener('click', event => {
    const root = event.target.closest?.(selector); if (!root) return;
    const button = event.target.closest('[data-dmf-filter]'), entry = entries.get(root);
    if (button && entry) {
      event.preventDefault();
      if (entry.category !== button.dataset.dmfFilter) filter(entry, button.dataset.dmfFilter, true);
      return;
    }
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    const guide = event.target.closest('[data-dmf-guide]');
    if (guide && root.dataset.autoGuide === 'true') {
      const target = guideTarget(root); if (!target || !target.getClientRects().length) return;
      event.preventDefault(); scrollToTarget(root, target, false); return;
    }
    const cta = event.target.closest('[data-dmf-cta]');
    if (!cta || root.dataset.autoCta !== 'true') return;
    const target = productTarget(root); if (!target || !target.getClientRects().length) return;
    event.preventDefault(); scrollToTarget(root, target, true);
  });
  document.addEventListener('keydown', event => {
    const button = event.target.closest?.('[data-dmf-filter]'), entry = button && entries.get(button.closest(selector));
    if (!entry) return;
    const buttons = entry.buttons.filter(item => !item.hidden), index = buttons.indexOf(button); let next;
    if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
    else if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = buttons.length - 1;
    else return;
    event.preventDefault(); buttons[next].focus({ preventScroll: true }); filter(entry, buttons[next].dataset.dmfFilter, true);
  });
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', event => rootsInside(event.target).forEach(destroy));
  document.addEventListener('shopify:section:select', event => rootsInside(event.target).forEach(root => root.querySelectorAll('[data-dmf-observed]').forEach(node => node.setAttribute('data-dmf-visible', ''))));
  document.addEventListener('shopify:block:select', event => {
    const id = String(event.detail?.blockId || ''); if (!id) return;
    boot(); entries.forEach(entry => {
      const item = entry.items.find(node => node.dataset.dmfBlock === id);
      if (!item) return;
      filter(entry, item.dataset.category); item.open = true;
      entry.root.querySelectorAll('[data-dmf-observed]').forEach(node => node.setAttribute('data-dmf-visible', ''));
    });
  });
  window.__driveMistFAQ1 = { boot }; boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lamboproduct"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__salvationEnglish13) { window.__salvationEnglish13(); return; }
  const busy = new WeakSet();
  const selector = '[data-salvation-v13]';
  const rootOf = target => target instanceof Element ? target.closest(selector) : null;
  const url = root => (root.dataset.root || '/').replace(/\/?$/, '/');
  const money = (root, value) => {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: root.dataset.currency || 'EUR' }).format(Number(value || 0) / 100); }
    catch { return (Number(value || 0) / 100).toFixed(2); }
  };
  const feedback = (root, text) => {
    const node = root.querySelector('[data-feedback]');
    if (node) { node.textContent = text; node.hidden = !text; }
  };
  const selected = root => root.querySelector('[data-offer]:has(input[type="radio"]:checked)') || root.querySelector('[data-offer]');
  const picks = card => Array.from(card?.querySelectorAll('[data-variant-picker]') || []).map(select => select.selectedOptions[0]);
  const basePrice = card => picks(card).reduce((sum, option) => sum + Number(option?.dataset.price || 0), 0);
  const price = (root, card) => {
    const base = basePrice(card);
    if (card?.dataset.priceMode === 'fixed_total') {
      const total = Number(card.dataset.fixedPrice);
      if (Number.isSafeInteger(total) && total >= 0) return Math.min(base, total);
    }
    if (card?.dataset.priceMode === 'fixed_amount') {
      const amount = Number(card.dataset.fixedAmount);
      if (Number.isSafeInteger(amount) && amount >= 0) return Math.max(0, base - amount);
    }
    return picks(card).reduce((sum, option) => sum + Math.round(Number(option?.dataset.price || 0) * (100 - Number(card.dataset.discount || 0)) / 100), 0);
  };
  const valid = card => picks(card).length > 0 && picks(card).every(option => option && !option.disabled && option.value);
  function refresh(root) {
    const active = selected(root);
    if (!active) return;
    root.querySelectorAll('[data-offer]').forEach(card => {
      const isActive = card === active;
      card.dataset.selected = String(isActive);
      const rows = card.querySelector('[data-server-rows]');
      if (rows) rows.disabled = !isActive;
      const output = card.querySelector('[data-offer-price]');
      if (output) output.textContent = money(root, price(root, card));
      const compare = card.querySelector('[data-offer-compare]');
      if (compare) {
        const amount = picks(card).reduce((sum, option) => sum + Math.max(Number(option?.dataset.price || 0), Number(option?.dataset.compare || 0)), 0);
        compare.textContent = money(root, amount); compare.hidden = amount <= price(root, card);
      }
    });
    const total = price(root, active);
    root.querySelectorAll('[data-main-price],[data-atc-price],[data-sticky-price]').forEach(node => { node.textContent = money(root, total); });
    const mainCompare = root.querySelector('[data-main-compare]');
    const activeCompare = active.querySelector('[data-offer-compare]');
    if (mainCompare && activeCompare) { mainCompare.textContent = activeCompare.textContent; mainCompare.hidden = activeCompare.hidden; }
    const summary = root.querySelector('[data-selection-summary]');
    if (summary) summary.textContent = `${picks(active).length} selected`;
    const note = root.querySelector('[data-discount-note]');
    if (note) note.hidden = price(root, active) >= basePrice(active);
    root.querySelectorAll('[data-atc],[data-buy-now],[data-sticky-atc]').forEach(button => { button.disabled = busy.has(root) || !valid(active); });
    const label = root.querySelector('[data-atc-label]');
    if (label) label.textContent = busy.has(root) ? root.dataset.adding : valid(active) ? root.dataset.originalAdd : root.dataset.soldOut;
    root.setAttribute('data-ready', '');
  }
  const galleryState = new WeakMap();
  const gallerySlides = root => Array.from(root.querySelectorAll('[data-slide]')).filter(slide => slide.dataset.eligible !== 'false');
  function hydrateImage(node, active = false) {
    const template = node?.querySelector('template[data-gallery-image]');
    if (template) { node.append(template.content.cloneNode(true)); template.remove(); }
    const image = node?.querySelector('img');
    if (image && active) { image.loading = 'eager'; image.fetchPriority = 'high'; }
    return image;
  }
  function filterGallery(root, option) {
    const all = Array.from(root.querySelectorAll('[data-slide]'));
    if (!all.length) return;
    let values = [];
    try { values = JSON.parse(option?.dataset.options || '[]'); } catch {}
    const normalize = value => String(value || '').trim().toLowerCase();
    const keys = [option?.value, option?.dataset.variantTitle, ...values].map(normalize).filter(Boolean);
    all.forEach(slide => {
      const mapped = normalize(slide.dataset.map);
      const general = slide.dataset.variantImage !== 'true';
      const matches = option && (slide.dataset.variantIds.split(',').includes(option.value) || slide.dataset.imageId === option.dataset.imageId || (mapped && keys.includes(mapped)));
      slide.dataset.eligible = String(general || Boolean(matches));
      slide.hidden = true;
    });
    // If every uploaded photo is assigned to a variant, keep one main photo as the initial fallback.
    if (!gallerySlides(root).length) (all.find(slide => slide.dataset.initial === 'true') || all[0]).dataset.eligible = 'true';
    const visible = gallerySlides(root);
    root.querySelectorAll('[data-thumb]').forEach((thumb, index) => {
      const position = visible.indexOf(all[index]);
      thumb.hidden = position < 0;
      thumb.dataset.thumb = String(position);
      if (position >= 0) hydrateImage(thumb);
    });
    const controls = root.querySelector('.svb__gallery-controls');
    if (controls) controls.hidden = visible.length < 2;
    galleryState.set(root, option || null);
    const preferred = option ? visible.findIndex(slide => slide.dataset.imageId === option.dataset.imageId || slide.dataset.variantImage === 'true') : 0;
    gallery(root, Math.max(0, preferred));
  }
  function gallery(root, index) {
    const slides = gallerySlides(root);
    if (!slides.length) return;
    const active = ((index % slides.length) + slides.length) % slides.length;
    root.dataset.galleryIndex = String(active);
    root.querySelectorAll('[data-slide]').forEach(slide => { slide.hidden = true; slide.classList.remove('svb__slide--changed'); });
    const slide = slides[active];
    hydrateImage(slide, true);
    slide.hidden = false;
    slide.classList.add('svb__slide--changed');
    root.querySelectorAll('[data-thumb]').forEach(thumb => thumb.setAttribute('aria-current', String(!thumb.hidden && Number(thumb.dataset.thumb) === active)));
    const count = root.querySelector('[data-gallery-count]');
    if (count) count.textContent = `${String(active + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    // Warm only the next eligible photo after the current image finishes, never unrelated variants.
    const warmNext = () => {
      if (gallerySlides(root)[Number(root.dataset.galleryIndex)] !== slide) return;
      const next = slides[(active + 1) % slides.length];
      const image = next !== slide && next.dataset.eligible !== 'false' ? hydrateImage(next) : null;
      if (image) { image.loading = 'eager'; image.fetchPriority = 'low'; }
    };
    const image = slide.querySelector('img');
    if (image?.complete) warmNext(); else image?.addEventListener('load', warmNext, { once: true });
  }
  function boot() {
    document.querySelectorAll(selector).forEach(root => {
      if (!root.dataset.originalAdd) root.dataset.originalAdd = root.querySelector('[data-atc-label]')?.textContent.trim() || 'Add to cart';
      refresh(root);
      if (!galleryState.has(root)) filterGallery(root, null);
    });
  }
  const pendingDiscounts = new WeakMap();
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const selectionKey = card => `${card?.dataset.blockId || ''}:${picks(card).map(option => option?.value || '').join(',')}`;
  const normalizeCode = value => String(value || '').trim().toUpperCase();
  const uniqueCodes = codes => Array.from(new Set(codes.map(normalizeCode).filter(Boolean)));
  function cartCodes(cart) {
    const codes = (cart.discount_codes || []).map(entry => entry.code);
    const applications = [...(cart.cart_level_discount_applications || [])];
    for (const item of cart.items || []) for (const allocation of item.line_level_discount_allocations || []) applications.push(allocation.discount_application);
    for (const application of applications) if (application?.type === 'discount_code') codes.push(application.title);
    return uniqueCodes(codes);
  }
  function productLines(root, cart) {
    const ids = new Set(Array.from(root.querySelectorAll('[data-variant-picker] option')).map(option => option.value));
    return (cart.items || []).filter(item => Number(item.product_id) === Number(root.dataset.productId) || ids.has(String(item.variant_id || item.id)));
  }
  function bestDeal(root, cart) {
    const quantity = productLines(root, cart).reduce((total, item) => total + Number(item.quantity || 0), 0);
    return Array.from(root.querySelectorAll('[data-offer]')).filter(card => Number(card.dataset.quantity) <= quantity && (price(root, card) < basePrice(card) || normalizeCode(card.dataset.discountCode))).sort((a, b) => Number(b.dataset.quantity) - Number(a.dataset.quantity) || (basePrice(b) - price(root, b)) - (basePrice(a) - price(root, a)))[0] || null;
  }
  function discountVerified(root, cart, deal) {
    if (!deal) return true;
    const code = normalizeCode(deal.dataset.discountCode), percent = Number(deal.dataset.discount || 0);
    if (code) {
      const declared = (cart.discount_codes || []).find(entry => normalizeCode(entry.code) === code);
      if (declared && !declared.applicable) return false;
      if (!declared && !cartCodes(cart).includes(code)) return false;
    }
    const lines = productLines(root, cart);
    if (!lines.length || lines.some(item => typeof (item.final_line_price ?? item.line_price) !== 'number')) return false;
    const original = lines.reduce((total, item) => total + Number(item.original_line_price ?? Number(item.original_price ?? item.price ?? 0) * Number(item.quantity || 0)), 0);
    const final = lines.reduce((total, item) => total + Number(item.final_line_price ?? item.line_price ?? 0), 0);
    const tolerance = lines.reduce((total, item) => total + Number(item.quantity || 0), 0);
    if (original <= 0 || final >= original) return false;
    if (deal.dataset.priceMode === 'fixed_total' || deal.dataset.priceMode === 'fixed_amount') {
      const count = Math.max(1, Number(deal.dataset.quantity || picks(deal).length));
      const quantity = lines.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
      const saving = Math.max(0, basePrice(deal) - price(root, deal));
      const expected = deal.dataset.priceMode === 'fixed_total' ? Math.min(original, Math.round(price(root, deal) * quantity / count)) : Math.max(0, Math.round(original - saving * quantity / count));
      return final <= expected;
    }
    return !percent || final <= Math.round(original * (100 - percent) / 100) + tolerance;
  }
  async function readCart(root) {
    const response = await fetch(`${url(root)}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(root.dataset.cartError || 'Could not load your cart.');
    const cart = await response.json();
    if (!Array.isArray(cart.items) || typeof cart.total_price !== 'number') throw new Error(root.dataset.cartError || 'Could not load your cart.');
    return cart;
  }
  async function reconcileDiscount(root, cart, sections = []) {
    const deal = bestDeal(root, cart), code = normalizeCode(deal?.dataset.discountCode);
    const productId = root.dataset.productId;
    const relatedRoots = Array.from(document.querySelectorAll(selector)).filter(node => node.dataset.productId === productId);
    const managed = uniqueCodes(relatedRoots.flatMap(node => Array.from(node.querySelectorAll('[data-offer]')).map(card => card.dataset.discountCode)));
    const existing = cartCodes(cart), preserved = existing.filter(item => !managed.includes(item));
    const requested = uniqueCodes([...preserved, code]);
    const changed = existing.slice().sort().join(',') !== requested.slice().sort().join(',');
    let updatedCart = false;
    if (code || changed) {
      const payload = { discount: requested.join(',') };
      if (sections.length) { payload.sections = sections; payload.sections_url = location.pathname + location.search; }
      const response = await fetch(`${url(root)}cart/update.js`, { method: 'POST', headers, body: JSON.stringify(payload) });
      const updated = await response.json();
      if (!response.ok || updated.status) throw new Error(updated.description || updated.message || root.dataset.bundleError);
      if (!Array.isArray(updated.items) || typeof updated.total_price !== 'number') throw new Error(root.dataset.bundleError);
      cart = updated; updatedCart = true;
    }
    return { cart, deal, updatedCart, verified: discountVerified(root, cart, deal) };
  }
  function markDiscount(root, verified) {
    if (verified) { delete root.dataset.bundleWarning; pendingDiscounts.delete(root); }
    else root.dataset.bundleWarning = root.dataset.bundleError || 'Your items are in the cart, but the bundle discount could not be applied. Please retry or check the cart total before checkout.';
  }
  function querySafe(scope, value) {
    if (!value) return null;
    try { return scope.querySelector(value); } catch { return null; }
  }
  function themeDrawer(root) {
    const custom = querySafe(document, root.dataset.themeDrawerSelector);
    const node = custom || document.querySelector('cart-drawer,#CartDrawer,[data-cart-drawer],.cart-drawer');
    return node?.closest('cart-drawer') || node;
  }
  function drawerPlan(root, drawer) {
    const wrapper = drawer?.closest('[id^="shopify-section-"]');
    const wrapperId = wrapper?.id.replace(/^shopify-section-/, '');
    const owner = wrapperId && !/(?:^|__)main-cart(?:-|$)/i.test(wrapperId) ? wrapperId : 'cart-drawer';
    return { keys: Array.from(new Set([owner, 'cart-drawer', 'cart-icon-bubble'])), owner };
  }
  function drawerFragment(root, html, drawer) {
    if (typeof html !== 'string' || !html.trim()) return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const source = querySafe(doc, root.dataset.themeDrawerSelector) || doc.querySelector('cart-drawer') || (drawer?.id ? doc.getElementById(drawer.id) : null) || doc.getElementById('CartDrawer');
    if (!source || source.querySelector('#main-cart-items,#main-cart-footer,[data-main-cart-items]')) return null;
    if (!source.matches('cart-drawer,#CartDrawer,[data-cart-drawer]') && !source.querySelector('cart-drawer-items,#CartDrawer-Form,#CartDrawer-CartItems')) return null;
    return { source, doc, html: `<div id="shopify-section-cart-drawer" class="shopify-section">${source.outerHTML}</div>` };
  }
  async function freshShrineCart(root, drawer) {
    const plan = drawerPlan(root, drawer);
    let cart = null, sections = {};
    try {
      const response = await fetch(`${url(root)}cart/update.js`, { method: 'POST', headers, body: JSON.stringify({ updates: {}, sections: plan.keys, sections_url: location.pathname + location.search }) });
      const result = await response.json();
      if (response.ok && !result.status && Array.isArray(result.items)) { cart = result; sections = result.sections || {}; }
    } catch {}
    const keys = Array.from(new Set([plan.owner, 'cart-drawer']));
    let fragment = keys.map(key => drawerFragment(root, sections[key], drawer)).find(Boolean);
    if (!fragment) {
      try {
        const target = new URL(location.href); target.hash = ''; target.searchParams.delete('sections'); target.searchParams.delete('section_id'); target.searchParams.set('_svb_drawer', String(Date.now()));
        const response = await fetch(target, { headers: { Accept: 'text/html' }, cache: 'no-store' });
        if (response.ok) fragment = drawerFragment(root, await response.text(), drawer);
      } catch {}
    }
    if (!cart) cart = await readCart(root);
    return { cart, sections, fragment };
  }
  function patchShrineDrawer(root, drawer, fragment) {
    if (!drawer || !fragment) return false;
    const source = fragment.source;
    const currentPanel = querySafe(drawer, root.dataset.themeDrawerContent) || drawer.querySelector('.drawer__inner');
    const freshPanel = querySafe(source, root.dataset.themeDrawerContent) || source.querySelector('.drawer__inner');
    if (currentPanel && freshPanel) {
      currentPanel.innerHTML = freshPanel.innerHTML;
      currentPanel.classList.remove('is-empty');
      currentPanel.hidden = false;
    } else {
      const currentCart = drawer.id === 'CartDrawer' ? drawer : drawer.querySelector('#CartDrawer');
      const freshCart = source.id === 'CartDrawer' ? source : source.querySelector('#CartDrawer');
      if (!currentCart || !freshCart) return false;
      currentCart.innerHTML = freshCart.innerHTML;
    }
    drawer.classList.remove('is-empty'); drawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
    return true;
  }
  function updateShrineCounter(root, cart, sections, fragment) {
    const bubble = document.getElementById('cart-icon-bubble');
    let replacement = null;
    if (typeof sections['cart-icon-bubble'] === 'string') replacement = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').getElementById('cart-icon-bubble');
    if (!replacement) replacement = fragment?.doc.getElementById('cart-icon-bubble');
    if (bubble && replacement) bubble.innerHTML = replacement.innerHTML;
    document.querySelectorAll('[data-cart-count],#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]').forEach(node => { node.textContent = String(cart.item_count); });
  }
  async function openThemeDrawer(root, drawer) {
    const button = root.querySelector('[data-atc]');
    try { drawer?.setActiveElement?.(button); } catch {}
    if (typeof drawer?.open === 'function') { try { await drawer.open(button); return true; } catch {} }
    if (typeof drawer?.show === 'function') { try { await drawer.show(); return true; } catch {} }
    if (drawer instanceof HTMLDialogElement) { if (!drawer.open) drawer.showModal(); return true; }
    if (drawer instanceof HTMLDetailsElement) { drawer.open = true; return true; }
    const triggerSelectors = root.dataset.themeCartTrigger || '#cart-icon-bubble,[aria-controls="CartDrawer"],[data-cart-toggle],[data-cart-drawer-open]';
    let triggers = [];
    try { triggers = Array.from(document.querySelectorAll(triggerSelectors)); } catch {}
    const trigger = triggers.find(node => node !== button && !root.contains(node) && !drawer?.contains(node));
    if (trigger) {
      const preventNavigation = event => event.preventDefault();
      trigger.addEventListener('click', preventNavigation, { capture: true, once: true });
      trigger.click();
      trigger.removeEventListener('click', preventNavigation, { capture: true });
      return true;
    }
    return false;
  }
  async function refreshThemeDrawer(root) {
    const drawer = themeDrawer(root);
    if (!drawer) return false;
    const fresh = await freshShrineCart(root, drawer);
    if (!fresh.fragment) return false;
    const sections = { 'cart-drawer': fresh.fragment.html };
    const bubbleHTML = fresh.sections['cart-icon-bubble'];
    if (typeof bubbleHTML === 'string' && !new DOMParser().parseFromString(bubbleHTML, 'text/html').querySelector('#main-cart-items,#main-cart-footer,cart-drawer,#CartDrawer')) sections['cart-icon-bubble'] = bubbleHTML;
    let rendered = false;
    if (typeof drawer.renderContents === 'function' && sections['cart-icon-bubble']) {
      try {
        drawer.setActiveElement?.(root.querySelector('[data-atc]'));
        drawer.classList.remove('is-empty');
        await drawer.renderContents({ ...fresh.cart, id: picks(selected(root))[0]?.value, sections });
        rendered = true;
      } catch {}
    }
    if (!rendered) rendered = patchShrineDrawer(root, drawer, fresh.fragment);
    if (!rendered) return false;
    updateShrineCounter(root, fresh.cart, fresh.sections, fresh.fragment);
    return await openThemeDrawer(root, drawer);
  }
  function renderDiscountStatus(root) {
    const discountButton = root.querySelector('[data-retry-bundle-discount]'), cartButton = root.querySelector('[data-retry-theme-cart]');
    if (discountButton) { discountButton.hidden = !root.dataset.bundleWarning; discountButton.disabled = busy.has(root); }
    if (cartButton) { cartButton.hidden = !root.dataset.drawerWarning; cartButton.disabled = busy.has(root); }
  }
  function resultFeedback(root, fallback) {
    feedback(root, [root.dataset.bundleWarning, root.dataset.drawerWarning].filter(Boolean).join(' ') || fallback);
    renderDiscountStatus(root);
  }
  async function syncAndOpen(root, cart, signature, verified, seed = {}) {
    let ready = false;
    try { ready = await refreshThemeDrawer(root, cart, seed); } catch {}
    if (ready) delete root.dataset.drawerWarning;
    else root.dataset.drawerWarning = root.dataset.drawerError || 'Your items are in the cart, but your theme drawer could not be refreshed. Please try Refresh cart.';
    if (verified && ready) pendingDiscounts.delete(root);
    else pendingDiscounts.set(root, { signature });
    return ready;
  }
  async function retryDiscount(root, checkout = false) {
    if (busy.has(root)) return;
    const signature = pendingDiscounts.get(root)?.signature || selectionKey(selected(root));
    busy.add(root); refresh(root); renderDiscountStatus(root);
    let cart = null;
    try {
      const outcome = await reconcileDiscount(root, await readCart(root));
      cart = await readCart(root);
      const verified = discountVerified(root, cart, bestDeal(root, cart));
      markDiscount(root, verified);
      if (checkout && verified) { location.assign(`${url(root)}checkout`); return; }
      await syncAndOpen(root, cart, signature, verified, outcome.cart.sections || {});
      resultFeedback(root, verified ? root.dataset.bundleApplied || 'Bundle discount applied.' : '');
    } catch {
      root.dataset.bundleWarning = root.dataset.bundleError || 'The bundle discount could not be applied. Your items are already in the cart.';
      try { cart = await readCart(root); await syncAndOpen(root, cart, signature, false); } catch { root.dataset.drawerWarning = root.dataset.drawerError; }
      pendingDiscounts.set(root, { signature }); resultFeedback(root, '');
    } finally { busy.delete(root); refresh(root); renderDiscountStatus(root); }
  }
  async function add(root, checkout) {
    if (busy.has(root)) return;
    if (!root.dataset.originalAdd) boot();
    const card = selected(root), signature = selectionKey(card);
    if (!valid(card)) { feedback(root, root.dataset.soldOut || 'Please select an available variant.'); return; }
    if (pendingDiscounts.get(root)?.signature === signature) { await retryDiscount(root, checkout); return; }
    busy.add(root); refresh(root); feedback(root, ''); renderDiscountStatus(root);
    delete root.dataset.bundleWarning; delete root.dataset.drawerWarning;
    let added = false;
    try {
      const grouped = new Map();
      picks(card).forEach(option => grouped.set(option.value, (grouped.get(option.value) || 0) + 1));
      const items = Array.from(grouped, ([id, quantity]) => ({ id: Number(id), quantity }));
      const plan = drawerPlan(root, themeDrawer(root));
      const response = await fetch(`${url(root)}cart/add.js`, { method: 'POST', headers, body: JSON.stringify({ items, sections: plan.keys, sections_url: location.pathname + location.search }) });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || root.dataset.error || 'Could not add this selection.');
      added = true; pendingDiscounts.set(root, { signature });
      const outcome = await reconcileDiscount(root, await readCart(root), plan.keys);
      const cart = await readCart(root), verified = discountVerified(root, cart, bestDeal(root, cart));
      markDiscount(root, verified);
      if (checkout && verified) { location.assign(`${url(root)}checkout`); return; }
      await syncAndOpen(root, cart, signature, verified, outcome.updatedCart ? outcome.cart.sections : result.sections);
      resultFeedback(root, root.dataset.success || 'Added to your cart.');
    } catch (error) {
      if (added) {
        root.dataset.bundleWarning = root.dataset.bundleError || 'The bundle discount could not be applied. Your items are already in the cart.';
        try { const cart = await readCart(root); await syncAndOpen(root, cart, signature, false); } catch { root.dataset.drawerWarning = root.dataset.drawerError; }
        pendingDiscounts.set(root, { signature }); resultFeedback(root, '');
      } else feedback(root, error.message || root.dataset.error || 'Could not add this selection.');
    } finally { busy.delete(root); refresh(root); renderDiscountStatus(root); }
  }
  document.addEventListener('submit', event => {
    const root = rootOf(event.target);
    if (!root || !event.target.matches('.svb__form')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    add(root, event.submitter?.matches('[data-buy-now]'));
  }, true);
  document.addEventListener('change', event => {
    const root = rootOf(event.target); if (!root) return;
    if (event.target.matches('.svb__offer-heading>input,[data-variant-picker]')) {
      refresh(root); feedback(root, '');
      if (event.target.matches('[data-variant-picker]')) filterGallery(root, event.target.selectedOptions[0]);
      else if (root.dataset.variantChosen === 'true') filterGallery(root, picks(selected(root))[0]);
      if (event.target.matches('[data-variant-picker]')) root.dataset.variantChosen = 'true';
    }
  }, true);
  document.addEventListener('click', async event => {
    const root = rootOf(event.target); if (!root) return;
    const target = event.target;
    const thumb = target.closest('[data-thumb]');
    if (thumb) { event.preventDefault(); gallery(root, Number(thumb.dataset.thumb)); }
    if (target.closest('[data-prev]')) gallery(root, Number(root.dataset.galleryIndex || 0) - 1);
    if (target.closest('[data-next]')) gallery(root, Number(root.dataset.galleryIndex || 0) + 1);
    if (target.closest('[data-sticky-atc]')) { event.preventDefault(); add(root, false); }
    const close = target.closest('[data-close]'); if (close) close.closest('dialog')?.close();
    if (target.closest('[data-size-guide]')) root.querySelector('[data-size-dialog]')?.showModal();
    if (target.closest('[data-retry-bundle-discount],[data-retry-theme-cart]')) { event.preventDefault(); await retryDiscount(root); }
    if (target.closest('[data-zoom]')) {
      const slide = gallerySlides(root)[Number(root.dataset.galleryIndex || 0)];
      const image = slide?.querySelector('img'); const dialog = root.querySelector('[data-lightbox]');
      if (image && dialog) { const zoom = image.cloneNode(); zoom.removeAttribute('srcset'); zoom.removeAttribute('sizes'); zoom.src = slide.dataset.full || image.currentSrc || image.src; zoom.loading = 'eager'; dialog.querySelector('[data-zoom-content]').replaceChildren(zoom); dialog.showModal(); }
    }
    const copy = target.closest('[data-copy-code]');
    if (copy) {
      try { await navigator.clipboard.writeText(copy.dataset.copyCode); copy.querySelector('[data-copy-label]').textContent = copy.dataset.copied || 'Copied ✓'; }
      catch { feedback(root, `${copy.dataset.fallback || 'Copy this code:'} ${copy.dataset.copyCode}`); }
    }
    if (target.matches('dialog')) { const box=target.getBoundingClientRect(); if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)target.close(); }
  }, true);
  let touch = null;
  document.addEventListener('touchstart', event => { const root=rootOf(event.target); if(root && event.target.closest('[data-slides]')) touch={root,x:event.changedTouches[0].clientX,y:event.changedTouches[0].clientY}; }, {passive:true});
  document.addEventListener('touchend', event => { if(!touch)return;const dx=event.changedTouches[0].clientX-touch.x,dy=event.changedTouches[0].clientY-touch.y;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy))gallery(touch.root,Number(touch.root.dataset.galleryIndex||0)+(dx<0?1:-1));touch=null; }, {passive:true});
  let frame;
  window.addEventListener('scroll', () => { if(frame)return;frame=requestAnimationFrame(()=>{frame=null;document.querySelectorAll(selector).forEach(root=>{const bar=root.querySelector('[data-sticky-bar]'),button=root.querySelector('[data-atc]');if(bar&&button)bar.hidden=button.getBoundingClientRect().bottom>=0||root.dataset.sticky!=='true';});}); }, {passive:true});
  window.__salvationEnglish13 = boot;
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  document.addEventListener('shopify:section:load', boot);
})();

(() => {
  if (window.__salvationBundleSwatches4) { window.__salvationBundleSwatches4(); return; }
  const rowStates = new WeakMap();
  const rootSelector = '[data-salvation-v13]';
  const rootOf = target => target instanceof Element ? target.closest(rootSelector) : null;
  const currentOf = state => state.variants.find(variant => variant.node.value === state.native.value);
  const matches = (variant, current, indices) => indices.every(index => variant.values[index] === current.values[index]);
  function sync(row) {
    const state = rowStates.get(row), root = rootOf(row);
    if (!state) return;
    const current = currentOf(state);
    if (!current) return;
    const soldOut = root?.dataset.soldOut || 'Sold out';
    row.querySelectorAll('[data-bundle-swatch]').forEach(button => {
      const index = Number(button.dataset.optionIndex), value = button.dataset.value;
      const matching = state.variants.filter(variant => variant.values[index] === value && matches(variant, current, state.hierarchy));
      const available = matching.some(variant => variant.available);
      button.hidden = !matching.length;
      button.disabled = !available;
      button.setAttribute('aria-disabled', String(!available));
      button.setAttribute('aria-pressed', String(!button.hidden && current.values[index] === value));
      button.title = `${button.dataset.colorLabel}${available ? '' : ` — ${soldOut}`}`;
      button.setAttribute('aria-label', button.title);
    });
    row.querySelectorAll('[data-bundle-option]').forEach(select => {
      const index = Number(select.dataset.optionIndex), position = state.hierarchy.indexOf(index);
      const upstream = state.hierarchy.slice(0, Math.max(0, position));
      Array.from(select.options).forEach(option => {
        const matching = state.variants.filter(variant => variant.values[index] === option.value && matches(variant, current, upstream));
        const available = matching.some(variant => variant.available);
        option.hidden = !matching.length;
        option.disabled = !available;
        option.textContent = `${option.dataset.baseLabel || option.value}${available ? '' : ` — ${soldOut}`}`;
      });
      select.value = current.values[index];
    });
    const caption = row.querySelector('[data-bundle-color-name]');
    if (caption) caption.textContent = row.querySelector('[data-bundle-swatch][aria-pressed="true"]')?.dataset.colorLabel || '';
  }
  function choose(row, index, value) {
    const state = rowStates.get(row);
    if (!state) return;
    const current = currentOf(state);
    if (!current) return;
    const position = state.hierarchy.indexOf(index);
    const upstream = position < 0 ? state.hierarchy : state.hierarchy.slice(0, position);
    const candidates = state.variants.filter(variant => variant.available && variant.values[index] === value && matches(variant, current, upstream));
    // Prefer existing downstream choices, but do not lock a brand to an unrelated model or colour.
    const score = variant => current.values.reduce((total, item, at) => total + (variant.values[at] === item ? (state.hierarchy.includes(at) ? 10 : 1) : 0), 0);
    const next = candidates.reduce((best, variant) => !best || score(variant) > score(best) ? variant : best, null);
    if (!next) { sync(row); return; }
    state.native.value = next.node.value;
    sync(row);
    state.native.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function boot() {
    document.querySelectorAll(`${rootSelector} [data-bundle-options]`).forEach(controls => {
      const row = controls.closest('.svb__item');
      if (rowStates.has(row)) { sync(row); return; }
      const native = row.querySelector('[data-variant-picker]');
      if (!native) return;
      let variants;
      try { variants = Array.from(native.options).map(node => ({ node, values: JSON.parse(node.dataset.options), available: !node.disabled })); }
      catch { return; }
      const count = Number(controls.dataset.optionCount);
      if (!count || !variants.length || variants.some(variant => !Array.isArray(variant.values) || variant.values.length !== count)) return;
      const fields = Array.from(row.querySelectorAll('[data-bundle-option]'));
      const brand = fields.find(select => /brand|marke|manufacturer|hersteller/i.test(select.dataset.optionName || ''));
      const hierarchy = [...(brand ? [brand] : []), ...fields.filter(select => select !== brand)].map(select => Number(select.dataset.optionIndex));
      rowStates.set(row, { native, variants, hierarchy });
      sync(row);
      controls.hidden = false;
      row.dataset.swatchReady = 'true';
    });
  }
  document.addEventListener('click', event => {
    if (!rootOf(event.target)) return;
    const button = event.target.closest('[data-bundle-swatch]');
    if (!button || button.hidden || button.matches(':disabled')) return;
    event.preventDefault();
    choose(button.closest('.svb__item'), Number(button.dataset.optionIndex), button.dataset.value);
  });
  document.addEventListener('change', event => {
    if (!rootOf(event.target)) return;
    const target = event.target;
    if (target.matches('[data-bundle-option]')) choose(target.closest('.svb__item'), Number(target.dataset.optionIndex), target.value);
    if (target.matches('[data-variant-picker]')) sync(target.closest('.svb__item'));
  });
  window.__salvationBundleSwatches4 = boot;
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  document.addEventListener('shopify:section:load', boot);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lamboreveal"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (window.__driveMistReveal1) { window.__driveMistReveal1.scan(); return; }
  var states = new Map();
  function init(root) {
    if (states.has(root)) return;
    var controller = new AbortController(), signal = controller.signal;
    var video = root.querySelector('video'), play = root.querySelector('[data-dmr-play]');
    var error = root.querySelector('[data-dmr-error]'), retry = root.querySelector('[data-dmr-retry]');
    var observers = [], failedSources = new Set(), activePointer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var state = { video: video, destroy: destroy, reveal: revealAll };
    states.set(root, state);
    root.setAttribute('data-dmr-ready', '');
    function on(el, name, callback, options) { if (el) el.addEventListener(name, callback, Object.assign({}, options, {signal: signal})); }
    function revealAll() { root.querySelectorAll('[data-dmr-reveal]').forEach(function (el) { el.setAttribute('data-dmr-visible', ''); }); }
    function pause() { if (video && !video.paused) video.pause(); }
    function destroy() {
      pause(); controller.abort(); observers.forEach(function (o) { o.disconnect(); });
      root.removeAttribute('data-dmr-ready');
      var range = root.querySelector('[data-dmr-range]'); if (range) range.disabled = true;
      var controls = root.querySelector('[data-dmr-comparison-controls]'); if (controls) controls.hidden = true;
      if (play) play.hidden = true;
      revealAll(); states.delete(root);
    }
    if (root.dataset.reveal === 'true' && !reduced.matches && 'IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.setAttribute('data-dmr-visible', ''); revealObserver.unobserve(entry.target); } });
      }, {threshold: 0.06});
      root.querySelectorAll('[data-dmr-reveal]').forEach(function (el) {
        if (el.getBoundingClientRect().top >= window.innerHeight) { el.setAttribute('data-dmr-observed', ''); revealObserver.observe(el); }
        else el.setAttribute('data-dmr-visible', '');
      }); observers.push(revealObserver);
    } else revealAll();
    on(reduced, 'change', function () { if (reduced.matches) revealAll(); });

    var frame = root.querySelector('[data-dmr-compare-frame]');
    var range = root.querySelector('[data-dmr-range]');
    if (frame && range) {
      var controls = root.querySelector('[data-dmr-comparison-controls]');
      range.disabled = false; if (controls) controls.hidden = false;
      function setSplit(value) {
        var split = Math.max(0, Math.min(100, Math.round(Number(value) || 0)));
        range.value = String(split); frame.style.setProperty('--dmr-split', split + '%');
        range.setAttribute('aria-valuetext', split + '% ' + root.dataset.offLabel + ' · ' + (100 - split) + '% ' + root.dataset.onLabel);
      }
      function move(event) { var rect = frame.getBoundingClientRect(); if (rect.width) setSplit((event.clientX - rect.left) / rect.width * 100); }
      setSplit(range.value);
      on(range, 'input', function () { setSplit(range.value); });
      on(root.querySelector('[data-dmr-off]'), 'click', function () { setSplit(100); });
      on(root.querySelector('[data-dmr-on]'), 'click', function () { setSplit(0); });
      on(frame, 'pointerdown', function (event) {
        if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0) || event.target.closest('button,input,a')) return;
        activePointer = event.pointerId;
        try { frame.setPointerCapture(activePointer); } catch (_) {  }
        move(event);
      });
      on(frame, 'pointermove', function (event) { if (event.pointerId === activePointer) move(event); });
      function release(event) {
        if (event.pointerId !== activePointer) return;
        try { if (frame.hasPointerCapture(activePointer)) frame.releasePointerCapture(activePointer); } catch (_) {  }
        activePointer = null;
      }
      on(frame, 'pointerup', release); on(frame, 'pointercancel', release); on(frame, 'lostpointercapture', function () { activePointer = null; });
    }

    if (video) {
      function showPlay() {
        if (!play) return;
        play.disabled = false; play.hidden = !video.paused || !!video.error || (error && !error.hidden);
        var label = play.querySelector('[data-dmr-play-label]');
        if (label) label.textContent = video.ended ? play.dataset.replayLabel : play.dataset.playLabel;
      }
      function showError() { if (error) error.hidden = false; if (retry) retry.hidden = false; if (play) { play.hidden = true; play.disabled = false; } }
      function clearError() { if (error) error.hidden = true; if (retry) retry.hidden = true; failedSources.clear(); }
      async function start() {
        if (play) play.disabled = true;
        if (video.ended) video.currentTime = 0;
        try { await video.play(); }
        catch (err) {
          if (signal.aborted) return;
          if (video.error || (err && err.name === 'NotSupportedError')) showError();
          else showPlay();
        }
      }
      on(play, 'click', start);
      on(video, 'play', function () {
        clearError(); if (play) { play.hidden = true; play.disabled = false; }
        states.forEach(function (other) { if (other !== state && other.video && !other.video.paused) other.video.pause(); });
      });
      on(video, 'pause', showPlay); on(video, 'ended', showPlay);
      on(video, 'error', showError);
      video.querySelectorAll('source').forEach(function (source) { on(source, 'error', function () {
        failedSources.add(source);
        if (failedSources.size >= video.querySelectorAll('source').length) showError();
      }); });
      on(retry, 'click', function () { clearError(); video.load(); showPlay(); start(); });
      on(video, 'loadedmetadata', function () { clearError(); showPlay(); });
      showPlay();
      if ('IntersectionObserver' in window) {
        var mediaObserver = new IntersectionObserver(function (entries) { entries.forEach(function (entry) { if (!entry.isIntersecting || entry.intersectionRatio < 0.1) pause(); }); }, {threshold: [0, 0.1]});
        mediaObserver.observe(video); observers.push(mediaObserver);
      }
    }

    var cta = root.querySelector('[data-dmr-cta]');
    on(cta, 'click', function (event) {
      if (root.dataset.autoCta !== 'true' || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var target = null, selector = root.dataset.target;
      if (selector) { try { target = document.querySelector(selector); } catch (_) {  } }
      if (!target && !selector) {
        var candidates = Array.from(document.querySelectorAll('[data-drivemist-product],[data-salvation-root]'));
        var matches = candidates.filter(function (el) { return !root.dataset.productId || !el.dataset.productId || el.dataset.productId === root.dataset.productId; });
        target = matches.filter(function (el) { return !!(el.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING); }).pop() || matches[0];
      }
      if (!target) return;
      var offers = target.matches('.svb__offers') ? target : target.querySelector('.svb__offers');
      var destination = offers || target;
      if (!destination.getClientRects().length) return;
      event.preventDefault();
      var offset = Math.max(0, Number(root.dataset.offset) || 0);
      window.scrollTo({top: Math.max(0, window.scrollY + destination.getBoundingClientRect().top - offset), behavior: reduced.matches || root.dataset.motion !== 'true' ? 'auto' : 'smooth'});
      var focus = destination.querySelector('input[type="radio"]:checked:not(:disabled)') || destination.querySelector('button:not(:disabled),select:not(:disabled),input:not(:disabled),a[href]');
      if (focus) focus.focus({preventScroll: true});
      else { var old = destination.getAttribute('tabindex'); destination.setAttribute('tabindex', '-1'); destination.focus({preventScroll: true}); destination.addEventListener('blur', function () { if (old === null) destination.removeAttribute('tabindex'); else destination.setAttribute('tabindex', old); }, {once: true}); }
    });
  }
  function scan(scope) {
    states.forEach(function (state, root) { if (!root.isConnected) state.destroy(); });
    var node = scope || document;
    if (node.matches && node.matches('[data-drivemist-reveal]')) init(node);
    node.querySelectorAll('[data-drivemist-reveal]').forEach(init);
  }
  window.__driveMistReveal1 = {scan: scan};
  document.addEventListener('visibilitychange', function () { if (document.hidden) states.forEach(function (s) { if (s.video) s.video.pause(); }); });
  window.addEventListener('pagehide', function () { states.forEach(function (s) { if (s.video) s.video.pause(); }); });
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { states.forEach(function (s, root) { if (event.target === root || event.target.contains(root)) s.destroy(); }); });
  document.addEventListener('shopify:section:select', function (event) { states.forEach(function (s, root) { if (event.target === root || event.target.contains(root)) s.reveal(); }); });
  document.addEventListener('shopify:block:select', function (event) { var root = event.target.closest('[data-drivemist-reveal]'); if (root && states.has(root)) states.get(root).reveal(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }, {once: true});
  else scan();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lambosection"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__driveMistSetup1) { window.__driveMistSetup1.boot(); return; }
  const selector = '[data-drivemist-setup]', entries = new Map();
  const zoomTriggers = new WeakMap();
  const reduced = root => root.dataset.motion !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
  const query = (value, scope = document) => { try { return scope.querySelector(value); } catch { return null; } };
  const rootsInside = target => target?.matches?.(selector) ? [target] : Array.from(target?.querySelectorAll?.(selector) || []);
  function update(entry, rebuild = false) {
    const { root, track, cards } = entry;
    if (!root.isConnected) return;
    if (rebuild || !entry.pages) {
      const max = Math.max(0, track.scrollWidth - track.clientWidth), left = track.getBoundingClientRect().left;
      const pages = [];
      cards.forEach((card, index) => {
        const position = Math.max(0, Math.min(max, track.scrollLeft + card.getBoundingClientRect().left - left));
        if (!pages.some(page => Math.abs(page.left - position) < 3)) pages.push({ left: position, card: index });
      });
      if (!pages.length) pages.push({ left: 0, card: 0 });
      const changed = !entry.pages || pages.length !== entry.pages.length;
      entry.pages = pages;
      if (changed) {
        const dots = query('[data-dms-dots]', root);
        if (dots) dots.replaceChildren(...pages.map((page, index) => {
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'dms__dot'; button.dataset.dmsDot = String(index);
          button.setAttribute('aria-label', `${root.dataset.pageLabel || ''} ${index + 1}`.trim());
          button.setAttribute('aria-controls', track.id);
          return button;
        }));
      }
    }
    let current = 0, distance = Infinity;
    entry.pages.forEach((page, index) => { const d = Math.abs(page.left - track.scrollLeft); if (d < distance) { current = index; distance = d; } });
    entry.index = current;
    root.dataset.pageIndex = String(current);
    root.dataset.slidable = String(entry.pages.length > 1);
    root.querySelectorAll('[data-dms-dot]').forEach((dot, index) => {
      if (index === current) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
    });
    const previous = query('[data-dms-prev]', root), next = query('[data-dms-next]', root);
    if (previous) previous.disabled = current === 0;
    if (next) next.disabled = current >= entry.pages.length - 1;
    const controls = query('[data-dms-controls]', root); if (controls) controls.hidden = entry.pages.length < 2;
    const counter = query('[data-dms-counter]', root); if (counter) counter.textContent = `${current + 1} / ${entry.pages.length}`;
  }
  function go(entry, index, announce = true) {
    if (!entry?.pages?.length) return;
    index = Math.max(0, Math.min(entry.pages.length - 1, Number(index) || 0));
    const page = entry.pages[index];
    entry.track.scrollTo({ left: page.left, behavior: reduced(entry.root) ? 'auto' : 'smooth' });
    if (announce) {
      const status = query('[data-dms-status]', entry.root);
      if (status) status.textContent = `${index + 1} / ${entry.pages.length}: ${entry.cards[page.card]?.dataset.dmsTitle || ''}`;
    }
    requestAnimationFrame(() => update(entry));
  }
  function showCard(entry, card) {
    if (!entry.pages?.length) return;
    const rect = card.getBoundingClientRect(), track = entry.track.getBoundingClientRect();
    if (rect.left >= track.left - 2 && rect.right <= track.right + 2) return;
    const index = entry.cards.indexOf(card);
    const target = entry.pages.reduce((best, page) => Math.abs(page.card - index) < Math.abs(best.card - index) ? page : best, entry.pages[0]);
    go(entry, entry.pages.indexOf(target), false);
  }
  function fail(video) {
    video.pause();
    const error = video.closest('[data-dms-card]')?.querySelector('[data-dms-error]');
    if (error) error.hidden = false;
    const retry = video.closest('[data-dms-card]')?.querySelector('[data-dms-retry]'); if (retry) retry.hidden = false;
  }
  function destroy(root) {
    const entry = entries.get(root); if (!entry) return;
    const dialog=query('[data-dms-dialog]',root); if(dialog?.open) dialog.close();
    root.querySelectorAll('[data-dms-zoom]').forEach(button=>button.hidden=true);
    entry.abort.abort(); entry.resize?.disconnect(); entry.visible?.disconnect(); entry.reveal?.disconnect();
    if (entry.frame) cancelAnimationFrame(entry.frame);
    root.querySelectorAll('video').forEach(video => video.pause());
    root.querySelectorAll('[data-dms-observed]').forEach(node => { node.removeAttribute('data-dms-observed'); node.removeAttribute('data-dms-visible'); });
    const controls = query('[data-dms-controls]', root); if (controls) controls.hidden = true;
    root.removeAttribute('data-dms-ready'); entries.delete(root);
  }
  function boot() {
    for (const root of entries.keys()) if (!root.isConnected) destroy(root);
    document.querySelectorAll(selector).forEach(root => {
      if (entries.has(root)) return;
      const track = query('[data-dms-track]', root); if (!track) return;
      const entry = { root, track, cards: Array.from(root.querySelectorAll('[data-dms-card]')), abort: new AbortController(), resize: null, visible: null, reveal: null, frame: null, index: 0 };
      entries.set(root, entry); const signal = entry.abort.signal;
      track.addEventListener('scroll', () => {
        if (entry.frame) return;
        entry.frame = requestAnimationFrame(() => { entry.frame = null; update(entry); });
      }, { passive: true, signal });
      if ('ResizeObserver' in window) {
        entry.resize = new ResizeObserver(() => update(entry, true)); entry.resize.observe(track);
      }
      if ('IntersectionObserver' in window) {
        entry.visible = new IntersectionObserver(items => items.forEach(item => { if (item.intersectionRatio < 0.15) item.target.pause(); }), { threshold: [0, 0.15] });
        if (!reduced(root) && root.dataset.reveal === 'true') {
          entry.reveal = new IntersectionObserver(items => items.forEach(item => { if (item.isIntersecting) { item.target.setAttribute('data-dms-visible', ''); entry.reveal.unobserve(item.target); } }), { threshold: 0.02, rootMargin: '0px 0px 80px 0px' });
          root.querySelectorAll('[data-dms-reveal]').forEach(node => {
            const rect = node.getBoundingClientRect();
            if (rect.top < innerHeight && rect.bottom > 0) node.setAttribute('data-dms-visible', '');
            else { node.setAttribute('data-dms-observed', ''); entry.reveal.observe(node); }
          });
        }
      }
      root.querySelectorAll('video').forEach(video => {
        const sources = Array.from(video.querySelectorAll('source')), failed = new Set();
        video.addEventListener('error', () => fail(video), { signal });
        sources.forEach(source => source.addEventListener('error', () => { failed.add(source); if (failed.size === sources.length) fail(video); }, { signal }));
        video.addEventListener('loadedmetadata', () => {
          failed.clear(); const error = video.closest('[data-dms-card]')?.querySelector('[data-dms-error]'); if (error) error.hidden = true;
          const retry = video.closest('[data-dms-card]')?.querySelector('[data-dms-retry]'); if (retry) retry.hidden = true;
        }, { signal });
        video.addEventListener('play', () => {
          if (document.hidden) { video.pause(); return; }
          document.querySelectorAll(`${selector} video`).forEach(other => { if (other !== video) other.pause(); });
        }, { signal });
        entry.visible?.observe(video);
      });
      root.querySelectorAll('[data-dms-zoom]').forEach(button=>button.hidden=typeof query('[data-dms-dialog]',root)?.showModal !== 'function');
      update(entry, true); root.setAttribute('data-dms-ready', '');
    });
  }
  function productTarget(root) {
    if ((root.dataset.target || '').trim()) {
      const target = query(root.dataset.target);
      return target?.matches('.svb__offers') ? target : target?.querySelector('.svb__offers') || target;
    }
    let products = Array.from(document.querySelectorAll('[data-drivemist-product]'));
    if (!products.length) products = Array.from(document.querySelectorAll('[data-salvation-root]'));
    if (root.dataset.productId) products = products.filter(product => !product.dataset.productId || product.dataset.productId === root.dataset.productId);
    const previous = products.filter(product => product.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING);
    const product = previous.at(-1) || products[0];
    return product?.querySelector('.svb__offers') || product || null;
  }
  document.addEventListener('click', event => {
    const root = event.target.closest?.(selector); if (!root) return;
    const entry = entries.get(root), dot = event.target.closest('[data-dms-dot]');
    if (dot && entry) { event.preventDefault(); go(entry, dot.dataset.dmsDot); return; }
    if (event.target.closest('[data-dms-prev]') && entry) { event.preventDefault(); go(entry, entry.index - 1); return; }
    if (event.target.closest('[data-dms-next]') && entry) { event.preventDefault(); go(entry, entry.index + 1); return; }
    const zoom=event.target.closest('[data-dms-zoom]');
    if(zoom && entry){
      const media=zoom.closest('.dms__media'), image=media?.querySelector('img'), dialog=query('[data-dms-dialog]',root);
      const src=matchMedia('(max-width:989px)').matches ? media?.dataset.dmsZoomMobile || media?.dataset.dmsZoomSrc : media?.dataset.dmsZoomSrc;
      if(image && src && dialog && !dialog.open && typeof dialog.showModal==='function'){
        const clone=image.cloneNode(); ['srcset','sizes','loading','id','style'].forEach(a=>clone.removeAttribute(a)); clone.src=src;
        query('[data-dms-zoom-content]',dialog).replaceChildren(clone); zoomTriggers.set(dialog,zoom); dialog.showModal();
      }
    }
    const dialog=query('[data-dms-dialog]',root);
    if(event.target.closest('[data-dms-close]')) dialog?.close();
    if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}
    const retry=event.target.closest('[data-dms-retry]');
    if(retry && entry){const video=retry.closest('[data-dms-card]')?.querySelector('video');if(video){video.load();video.play().catch(()=>{if(video.error)fail(video);});}}
    const cta = event.target.closest('[data-dms-cta]');
    if (!cta || root.dataset.autoCta !== 'true' || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    const target = productTarget(root); if (!target || !target.getClientRects().length) return;
    event.preventDefault(); root.querySelectorAll('video').forEach(video => video.pause());
    window.scrollTo({ top: Math.max(0, scrollY + target.getBoundingClientRect().top - Math.max(0,Number(root.dataset.offset)||0)), behavior: reduced(root) ? 'auto' : 'smooth' });
    const control = target.matches('input,button,a,select') ? target : query('input[type="radio"]:checked:not(:disabled),[data-bundle-option]:not(:disabled),[data-atc]:not(:disabled)', target);
    control?.focus({ preventScroll: true });
  });
  document.addEventListener('keydown', event => {
    if (!event.target.matches?.('[data-dms-track]')) return;
    const entry = entries.get(event.target.closest(selector)); if (!entry) return;
    let index;
    if (event.key === 'ArrowRight') index = entry.index + 1;
    else if (event.key === 'ArrowLeft') index = entry.index - 1;
    else if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = entry.pages.length - 1;
    else return;
    event.preventDefault(); go(entry, index);
  });
  document.addEventListener('close',event=>{
    if(!event.target.matches?.('[data-dms-dialog]'))return;
    const trigger=zoomTriggers.get(event.target); if(trigger?.isConnected)trigger.focus({preventScroll:true});
    query('[data-dms-zoom-content]',event.target)?.replaceChildren();
  },true);
  window.addEventListener('pagehide',()=>document.querySelectorAll(`${selector} video`).forEach(video=>video.pause()));
  document.addEventListener('visibilitychange', () => { if (document.hidden) document.querySelectorAll(`${selector} video`).forEach(video => video.pause()); });
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', event => rootsInside(event.target).forEach(destroy));
  document.addEventListener('shopify:section:select', event => rootsInside(event.target).forEach(root => root.querySelectorAll('[data-dms-observed]').forEach(node => node.setAttribute('data-dms-visible', ''))));
  document.addEventListener('shopify:block:select', event => {
    const id = String(event.detail?.blockId || ''); if (!id) return;
    boot(); entries.forEach(entry => {
      const card = entry.cards.find(node => node.dataset.dmsBlock === id);
      if (card) { entry.root.querySelectorAll('[data-dms-observed]').forEach(node => node.setAttribute('data-dms-visible', '')); showCard(entry, card); }
    });
  });
  window.__driveMistSetup1 = { boot }; boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["little-fit"] && !Shopify.designMode) return;
  try {
    
(() => {
 if(window.__littleReindeerFit1){window.__littleReindeerFit1.boot();return}
 const selector='[data-little-fit]',entries=new WeakMap();
 const reduced=root=>root.dataset.motion!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches;
 const observer='IntersectionObserver'in window?new IntersectionObserver(items=>items.forEach(item=>{if(item.isIntersecting){item.target.dataset.visible='true';observer.unobserve(item.target)}}),{threshold:.12}):null;
 function number(raw){const value=String(raw||'').trim();if(!/^\d+(?:[.,]\d+)?$/.test(value))return null;const n=Number(value.replace(',','.'));return Number.isFinite(n)&&n>0?n:null}
 function measure(raw,unit){const n=number(raw);return n===null?'—':String(Math.round((unit==='in'?n/2.54:n)*10)/10)}
 function render(entry,announce=false){const{root,buttons}=entry;const active=buttons[entry.index];if(!active)return;root.querySelectorAll('[data-fit-unit]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.fitUnit===entry.unit)));buttons.forEach((button,i)=>{button.setAttribute('aria-checked',String(i===entry.index));button.tabIndex=i===entry.index?0:-1});root.querySelector('[data-fit-selected]').textContent=active.dataset.label;root.querySelectorAll('[data-fit-metric]').forEach(node=>{const value=measure(active.dataset[node.dataset.fitMetric],entry.unit);node.textContent=value==='—'?value:value+' '+entry.unit});const note=root.querySelector('[data-fit-note]');note.textContent=active.dataset.note;note.hidden=!active.dataset.note;root.querySelectorAll('[data-fit-cell]').forEach(node=>node.textContent=measure(node.dataset.cm,entry.unit));root.querySelectorAll('[data-fit-table-unit]').forEach(node=>node.textContent='('+entry.unit+')');root.querySelectorAll('[data-fit-row]').forEach(row=>row.classList.toggle('is-selected',Number(row.dataset.fitRow)===entry.index));root.querySelectorAll('[data-fit-row-button]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.fitRowButton)===entry.index)));root.dataset.activeSize=String(entry.index);if(announce)root.querySelector('[data-fit-status]').textContent=active.dataset.label+': '+Array.from(root.querySelectorAll('[data-fit-metric]')).map(node=>node.previousElementSibling.textContent+' '+node.textContent).join(', ')}
 function boot(){document.querySelectorAll(selector).forEach(root=>{if(entries.has(root))return;const buttons=Array.from(root.querySelectorAll('[data-fit-size]'));const entry={root,buttons,index:Math.max(0,Math.min(buttons.length-1,Number(root.dataset.initial)||0)),unit:root.dataset.unit==='in'?'in':'cm'};entries.set(root,entry);root.querySelectorAll('[data-fit-size],[data-fit-row-button]').forEach(button=>button.disabled=false);render(entry);root.dataset.ready='true';if(observer&&root.dataset.reveal==='true'&&!reduced(root)){root.dataset.observed='true';observer.observe(root)}else root.dataset.visible='true'})}
 document.addEventListener('click',event=>{const root=event.target.closest?.(selector),entry=root&&entries.get(root);if(!entry)return;const size=event.target.closest('[data-fit-size],[data-fit-row-button]'),unit=event.target.closest('[data-fit-unit]');if(size){event.preventDefault();entry.index=Number(size.dataset.fitSize??size.dataset.fitRowButton);render(entry,true)}if(unit){event.preventDefault();entry.unit=unit.dataset.fitUnit;render(entry,true)}const cta=event.target.closest('[data-fit-cta]');if(!cta||root.dataset.autoCta!=='true'||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button>0)return;let target=null;if(root.dataset.target.trim()){try{target=document.querySelector(root.dataset.target)}catch{}}else{const all=Array.from(document.querySelectorAll('[data-salvation-root]')),product=all.filter(node=>node.compareDocumentPosition(root)&Node.DOCUMENT_POSITION_FOLLOWING).pop()||all[0];target=product?.querySelector('.svb__offers')||product}if(!target)return;event.preventDefault();window.scrollTo({top:Math.max(0,scrollY+target.getBoundingClientRect().top-Number(root.dataset.offset||0)),behavior:reduced(root)?'auto':'smooth'});target.querySelector('[data-bundle-option]:not(:disabled),input:checked,button:not(:disabled)')?.focus({preventScroll:true})});
 document.addEventListener('keydown',event=>{const button=event.target.closest?.('[data-fit-size]'),entry=button&&entries.get(button.closest(selector));if(!entry)return;let next;const i=entry.buttons.indexOf(button);if(event.key==='ArrowRight'||event.key==='ArrowDown')next=(i+1)%entry.buttons.length;else if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=(i-1+entry.buttons.length)%entry.buttons.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=entry.buttons.length-1;else return;event.preventDefault();entry.index=next;render(entry,true);entry.buttons[next].focus({preventScroll:true})});
 document.addEventListener('shopify:section:load',boot);
 document.addEventListener('shopify:block:select',event=>{const id=String(event.detail?.blockId||'');document.querySelectorAll(selector).forEach(root=>{const entry=entries.get(root);if(!entry)return;const index=entry.buttons.findIndex(button=>button.dataset.fitBlock===id);if(index>=0){entry.index=index;render(entry)}const faq=Array.from(root.querySelectorAll('[data-fit-faq]')).find(node=>node.dataset.fitFaq===id);if(faq)faq.open=true})});
 document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll?.(selector).forEach(root=>observer?.unobserve(root)));
 window.__littleReindeerFit1={boot};boot();if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memory"] && !Shopify.designMode) return;
  try {
    
(() => {
 if(window.__reindeerMemories1){window.__reindeerMemories1.boot();return}
 const selector='[data-reindeer-memories]',entries=new Map();
 const reduced=root=>root.dataset.motion!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches;
 const observer='IntersectionObserver'in window?new IntersectionObserver(items=>items.forEach(item=>{if(item.isIntersecting){item.target.dataset.visible='true';observer.unobserve(item.target)}}),{threshold:.12}):null;
 function update(entry){const{root,track,items}=entry;if(!root.isConnected)return;const center=track.getBoundingClientRect().left+track.clientWidth/2;let distance=Infinity,index=0;items.forEach((item,i)=>{const r=item.getBoundingClientRect(),d=Math.abs(r.left+r.width/2-center);if(d<distance){distance=d;index=i}});entry.index=index;root.querySelectorAll('[data-mm-dot]').forEach((dot,i)=>{if(i===index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});const prev=root.querySelector('[data-mm-prev]'),next=root.querySelector('[data-mm-next]');if(prev)prev.disabled=index===0;if(next)next.disabled=index===items.length-1;}
 function go(entry,index,announce=true){if(!entry)return;index=Math.max(0,Math.min(entry.items.length-1,Number(index)||0));const item=entry.items[index];if(!item)return;item.dataset.visible='true';if(innerWidth<750&&entry.root.dataset.mobileLayout==='swipe'){const left=item.getBoundingClientRect().left-entry.track.getBoundingClientRect().left+entry.track.scrollLeft-8;entry.track.scrollTo({left,behavior:reduced(entry.root)?'auto':'smooth'})}if(announce)entry.root.querySelector('[data-mm-status]').textContent=`${index+1} / ${entry.items.length}: ${item.querySelector('h3')?.textContent || item.dataset.reviewName || entry.root.dataset.galleryLabel}`;update(entry);}
 function boot(){for(const[root,entry]of entries)if(!root.isConnected){entry.resize?.disconnect();entry.items.forEach(item=>observer?.unobserve(item));entries.delete(root)}document.querySelectorAll(selector).forEach(root=>{if(entries.has(root))return;const track=root.querySelector('[data-mm-track]');if(!track)return;const items=Array.from(track.querySelectorAll('[data-mm-item]')),entry={root,track,items,index:0};entries.set(root,entry);const dialog=root.querySelector('[data-memory-lightbox]');dialog?.addEventListener('close',()=>{if(entry.opener?.isConnected)entry.opener.focus({preventScroll:true})});const controls=root.querySelector('[data-mm-controls]');if(controls)controls.hidden=items.length<2;track.addEventListener('scroll',()=>{if(entry.frame)return;entry.frame=requestAnimationFrame(()=>{entry.frame=null;update(entry)})},{passive:true});if('ResizeObserver'in window){entry.resize=new ResizeObserver(()=>update(entry));entry.resize.observe(track)}if(root.dataset.reveal==='true'&&!reduced(root)&&observer)items.forEach(item=>{item.dataset.observed='true';observer.observe(item)});else items.forEach(item=>item.dataset.visible='true');update(entry);root.dataset.ready='true'})}
 document.addEventListener('click',event=>{const root=event.target.closest?.(selector);if(!root)return;const entry=entries.get(root);if(!entry)return;const photo=event.target.closest('[data-memory-photo]'),dialog=root.querySelector('[data-memory-lightbox]');if(photo&&dialog){event.preventDefault();entry.opener=photo;const image=dialog.querySelector('[data-memory-large]');image.src=photo.dataset.full;image.alt=photo.dataset.photoAlt;dialog.querySelector('[data-memory-photo-title]').textContent=photo.dataset.photoAlt||root.dataset.galleryLabel;if(!dialog.open)dialog.showModal()}if(event.target.closest('[data-memory-close]')){event.preventDefault();dialog?.close()}if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close()}const dot=event.target.closest('[data-mm-dot]');if(dot){event.preventDefault();go(entry,dot.dataset.mmDot)}if(event.target.closest('[data-mm-prev]')){event.preventDefault();go(entry,entry.index-1)}if(event.target.closest('[data-mm-next]')){event.preventDefault();go(entry,entry.index+1)}const cta=event.target.closest('[data-mm-cta]');if(!cta||root.dataset.autoCta!=='true'||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button>0)return;let target=null;if(root.dataset.ctaSelector.trim()){try{target=document.querySelector(root.dataset.ctaSelector)}catch{}}else{const candidates=Array.from(document.querySelectorAll('[data-salvation-root]')),product=candidates.filter(node=>node.compareDocumentPosition(root)&Node.DOCUMENT_POSITION_FOLLOWING).pop()||candidates[0];target=product?.querySelector('.svb__offers')||product}if(!target)return;event.preventDefault();window.scrollTo({top:Math.max(0,scrollY+target.getBoundingClientRect().top-Number(root.dataset.scrollOffset||0)),behavior:reduced(root)?'auto':'smooth'});target.querySelector('[data-bundle-option]:not(:disabled),input:checked,button:not(:disabled)')?.focus({preventScroll:true})});
 document.addEventListener('keydown',event=>{if(!event.target.matches?.('[data-mm-track]'))return;const entry=entries.get(event.target.closest(selector));if(!entry||innerWidth>=750||entry.root.dataset.mobileLayout!=='swipe')return;let index;if(event.key==='ArrowRight')index=entry.index+1;else if(event.key==='ArrowLeft')index=entry.index-1;else if(event.key==='Home')index=0;else if(event.key==='End')index=entry.items.length-1;else return;event.preventDefault();go(entry,index)});
 document.addEventListener('shopify:section:load',boot);
 document.addEventListener('shopify:block:select',event=>{const id=String(event.detail?.blockId||'');for(const entry of entries.values()){const index=entry.items.findIndex(item=>item.dataset.mmBlock===id);if(index>=0)go(entry,index,false)}});
 document.addEventListener('shopify:section:unload',event=>{for(const[root,entry]of entries)if(event.target===root||event.target.contains(root)){root.querySelector('[data-memory-lightbox]')?.close();entry.resize?.disconnect();entry.items.forEach(item=>observer?.unobserve(item));entries.delete(root)}});
 window.__reindeerMemories1={boot};boot();if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["month"] && !Shopify.designMode) return;
  try {
    
(() => {
 if(window.__reindeerMoments1){window.__reindeerMoments1.boot();return}
 const selector='[data-reindeer-moments]',entries=new Map();
 const reduced=root=>root.dataset.motion!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches;
 const observer='IntersectionObserver'in window?new IntersectionObserver(items=>items.forEach(item=>{if(item.isIntersecting){item.target.dataset.visible='true';observer.unobserve(item.target)}}),{threshold:.12}):null;
 function update(entry){const{root,track,items}=entry;if(!root.isConnected)return;const center=track.getBoundingClientRect().left+track.clientWidth/2;let distance=Infinity,index=0;items.forEach((item,i)=>{const r=item.getBoundingClientRect(),d=Math.abs(r.left+r.width/2-center);if(d<distance){distance=d;index=i}});entry.index=index;root.querySelectorAll('[data-mm-dot]').forEach((dot,i)=>{if(i===index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});const prev=root.querySelector('[data-mm-prev]'),next=root.querySelector('[data-mm-next]');if(prev)prev.disabled=index===0;if(next)next.disabled=index===items.length-1;}
 function go(entry,index,announce=true){if(!entry)return;index=Math.max(0,Math.min(entry.items.length-1,Number(index)||0));const item=entry.items[index];if(!item)return;item.dataset.visible='true';if(innerWidth<750&&entry.root.dataset.mobileLayout==='swipe'){const left=item.getBoundingClientRect().left-entry.track.getBoundingClientRect().left+entry.track.scrollLeft-8;entry.track.scrollTo({left,behavior:reduced(entry.root)?'auto':'smooth'})}if(announce)entry.root.querySelector('[data-mm-status]').textContent=`${index+1} / ${entry.items.length}: ${item.querySelector('h3').textContent}`;update(entry);}
 function boot(){for(const[root,entry]of entries)if(!root.isConnected){entry.resize?.disconnect();entry.items.forEach(item=>observer?.unobserve(item));entries.delete(root)}document.querySelectorAll(selector).forEach(root=>{if(entries.has(root))return;const track=root.querySelector('[data-mm-track]');if(!track)return;const items=Array.from(track.querySelectorAll('[data-mm-item]')),entry={root,track,items,index:0};entries.set(root,entry);const controls=root.querySelector('[data-mm-controls]');if(controls)controls.hidden=items.length<2;track.addEventListener('scroll',()=>{if(entry.frame)return;entry.frame=requestAnimationFrame(()=>{entry.frame=null;update(entry)})},{passive:true});if('ResizeObserver'in window){entry.resize=new ResizeObserver(()=>update(entry));entry.resize.observe(track)}if(root.dataset.reveal==='true'&&!reduced(root)&&observer)items.forEach(item=>{item.dataset.observed='true';observer.observe(item)});else items.forEach(item=>item.dataset.visible='true');update(entry);root.dataset.ready='true'})}
 document.addEventListener('click',event=>{const root=event.target.closest?.(selector);if(!root)return;const entry=entries.get(root),dot=event.target.closest('[data-mm-dot]');if(dot){event.preventDefault();go(entry,dot.dataset.mmDot)}if(event.target.closest('[data-mm-prev]')){event.preventDefault();go(entry,entry.index-1)}if(event.target.closest('[data-mm-next]')){event.preventDefault();go(entry,entry.index+1)}const cta=event.target.closest('[data-mm-cta]');if(!cta||root.dataset.autoCta!=='true'||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button>0)return;let target=null;if(root.dataset.ctaSelector.trim()){try{target=document.querySelector(root.dataset.ctaSelector)}catch{}}else{const candidates=Array.from(document.querySelectorAll('[data-salvation-root]')),product=candidates.filter(node=>node.compareDocumentPosition(root)&Node.DOCUMENT_POSITION_FOLLOWING).pop()||candidates[0];target=product?.querySelector('.svb__offers')||product}if(!target)return;event.preventDefault();window.scrollTo({top:Math.max(0,scrollY+target.getBoundingClientRect().top-Number(root.dataset.scrollOffset||0)),behavior:reduced(root)?'auto':'smooth'});target.querySelector('[data-bundle-option]:not(:disabled),input:checked,button:not(:disabled)')?.focus({preventScroll:true})});
 document.addEventListener('keydown',event=>{if(!event.target.matches?.('[data-mm-track]'))return;const entry=entries.get(event.target.closest(selector));if(!entry||innerWidth>=750||entry.root.dataset.mobileLayout!=='swipe')return;let index;if(event.key==='ArrowRight')index=entry.index+1;else if(event.key==='ArrowLeft')index=entry.index-1;else if(event.key==='Home')index=0;else if(event.key==='End')index=entry.items.length-1;else return;event.preventDefault();go(entry,index)});
 document.addEventListener('shopify:section:load',boot);
 document.addEventListener('shopify:block:select',event=>{const id=String(event.detail?.blockId||'');for(const entry of entries.values()){const index=entry.items.findIndex(item=>item.dataset.mmBlock===id);if(index>=0)go(entry,index,false)}});
 document.addEventListener('shopify:section:unload',event=>{for(const[root,entry]of entries)if(event.target===root||event.target.contains(root)){entry.resize?.disconnect();entry.items.forEach(item=>observer?.unobserve(item));entries.delete(root)}});
 window.__reindeerMoments1={boot};boot();if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outfit"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__littleAwwCompare) { window.__littleAwwCompare.boot(); return; }
  const selector = '[data-little-aww]', initialized = new WeakSet();
  const reduced = root => root.dataset.motion !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
  function set(root, value) {
    const range = root.querySelector('[data-aww-range]');
    const position = Math.min(100, Math.max(0, Number(value) || 0));
    range.value = String(position); root.style.setProperty('--aw-pos', position + '%');
    range.setAttribute('aria-valuetext', `${root.dataset.beforeLabel}: ${position}% · ${root.dataset.afterLabel}: ${100 - position}%`);
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => { entries.forEach(entry => { if (entry.isIntersecting) { entry.target.dataset.visible = 'true'; observer.unobserve(entry.target); } }); }, { threshold: .12 }) : null;
  function boot() {
    document.querySelectorAll(selector).forEach(root => {
      if (initialized.has(root)) return;
      initialized.add(root);
      const range = root.querySelector('[data-aww-range]'); if (!range) return;
      set(root, root.dataset.position); range.disabled = false;
      root.querySelectorAll('[data-aww-set]').forEach(button => { button.disabled = false; });
      root.dataset.ready = 'true';
      if (observer && !reduced(root) && root.dataset.reveal === 'true') { root.dataset.observed = 'true'; observer.observe(root); }
      else root.dataset.visible = 'true';
    });
  }
  document.addEventListener('input', event => { if (event.target.matches('[data-aww-range]')) { const root = event.target.closest(selector); if (root) set(root, event.target.value); } });
  document.addEventListener('click', event => {
    const root = event.target.closest?.(selector); if (!root) return;
    const endpoint = event.target.closest('[data-aww-set]');
    if (endpoint) { event.preventDefault(); set(root, endpoint.dataset.awwSet); }
    const cta = event.target.closest('[data-aww-cta]');
    if (!cta || root.dataset.autoCta !== 'true' || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    let target = null;
    if (root.dataset.ctaSelector.trim()) { try { target = document.querySelector(root.dataset.ctaSelector); } catch {} }
    else {
      const candidates = Array.from(document.querySelectorAll('[data-salvation-root]'));
      const product = candidates.filter(node => node.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING).pop() || candidates[0];
      target = product?.querySelector('.svb__offers') || product;
    }
    if (!target) return;
    event.preventDefault();
    window.scrollTo({ top: Math.max(0, scrollY + target.getBoundingClientRect().top - Number(root.dataset.scrollOffset || 0)), behavior: reduced(root) ? 'auto' : 'smooth' });
    const focus = target.querySelector('[data-bundle-option]:not(:disabled),input:checked,button:not(:disabled)');
    focus?.focus({ preventScroll: true });
  });
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', event => { event.target.querySelectorAll?.(selector).forEach(root => observer?.unobserve(root)); });
  window.__littleAwwCompare = { boot };
  boot(); if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productview"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__salvationEnglish13) { window.__salvationEnglish13(); return; }
  const busy = new WeakSet();
  const selector = '[data-salvation-v13]';
  const rootOf = target => target instanceof Element ? target.closest(selector) : null;
  const url = root => (root.dataset.root || '/').replace(/\/?$/, '/');
  const money = (root, value) => {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: root.dataset.currency || 'EUR' }).format(Number(value || 0) / 100); }
    catch { return (Number(value || 0) / 100).toFixed(2); }
  };
  const feedback = (root, text) => {
    const node = root.querySelector('[data-feedback]');
    if (node) { node.textContent = text; node.hidden = !text; }
  };
  const selected = root => root.querySelector('[data-offer]:has(input[type="radio"]:checked)') || root.querySelector('[data-offer]');
  const picks = card => Array.from(card?.querySelectorAll('[data-variant-picker]') || []).map(select => select.selectedOptions[0]);
  const price = (root, card) => picks(card).reduce((sum, option) => sum + Math.round(Number(option?.dataset.price || 0) * (100 - Number(card.dataset.discount || 0)) / 100), 0);
  const valid = card => picks(card).length > 0 && picks(card).every(option => option && !option.disabled && option.value);
  function refresh(root) {
    const active = selected(root);
    if (!active) return;
    root.querySelectorAll('[data-offer]').forEach(card => {
      const isActive = card === active;
      card.dataset.selected = String(isActive);
      const rows = card.querySelector('[data-server-rows]');
      if (rows) rows.disabled = !isActive;
      const output = card.querySelector('[data-offer-price]');
      if (output) output.textContent = money(root, price(root, card));
      const compare = card.querySelector('[data-offer-compare]');
      if (compare) {
        const amount = picks(card).reduce((sum, option) => sum + Math.max(Number(option?.dataset.price || 0), Number(option?.dataset.compare || 0)), 0);
        compare.textContent = money(root, amount); compare.hidden = amount <= price(root, card);
      }
    });
    const total = price(root, active);
    root.querySelectorAll('[data-main-price],[data-atc-price],[data-sticky-price]').forEach(node => { node.textContent = money(root, total); });
    const mainCompare = root.querySelector('[data-main-compare]');
    const activeCompare = active.querySelector('[data-offer-compare]');
    if (mainCompare && activeCompare) { mainCompare.textContent = activeCompare.textContent; mainCompare.hidden = activeCompare.hidden; }
    const summary = root.querySelector('[data-selection-summary]');
    if (summary) summary.textContent = `${picks(active).length} selected`;
    const note = root.querySelector('[data-discount-note]');
    if (note) note.hidden = !Number(active.dataset.discount);
    root.querySelectorAll('[data-atc],[data-buy-now],[data-sticky-atc]').forEach(button => { button.disabled = busy.has(root) || !valid(active); });
    const label = root.querySelector('[data-atc-label]');
    if (label) label.textContent = busy.has(root) ? root.dataset.adding : valid(active) ? root.dataset.originalAdd : root.dataset.soldOut;
    root.setAttribute('data-ready', '');
  }
  function gallery(root, index) {
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    if (!slides.length) return;
    const active = (index + slides.length) % slides.length;
    root.dataset.galleryIndex = String(active);
    slides.forEach((slide, i) => { slide.hidden = i !== active; slide.classList.toggle('svb__slide--changed', i === active); });
    root.querySelectorAll('[data-thumb]').forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === active)));
    const count = root.querySelector('[data-gallery-count]');
    if (count) count.textContent = `${String(active + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
  }
  function boot() {
    document.querySelectorAll(selector).forEach(root => {
      if (!root.dataset.originalAdd) root.dataset.originalAdd = root.querySelector('[data-atc-label]')?.textContent.trim() || 'Add to cart';
      refresh(root);
      if (!root.dataset.galleryIndex) gallery(root, 0);
    });
  }
  const pendingDiscounts = new WeakMap();
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const selectionKey = card => `${card?.dataset.blockId || ''}:${picks(card).map(option => option?.value || '').join(',')}`;
  const normalizeCode = value => String(value || '').trim().toUpperCase();
  const uniqueCodes = codes => Array.from(new Set(codes.map(normalizeCode).filter(Boolean)));
  function cartCodes(cart) {
    const codes = (cart.discount_codes || []).map(entry => entry.code);
    const applications = [...(cart.cart_level_discount_applications || [])];
    for (const item of cart.items || []) for (const allocation of item.line_level_discount_allocations || []) applications.push(allocation.discount_application);
    for (const application of applications) if (application?.type === 'discount_code') codes.push(application.title);
    return uniqueCodes(codes);
  }
  function productLines(root, cart) {
    const ids = new Set(Array.from(root.querySelectorAll('[data-variant-picker] option')).map(option => option.value));
    return (cart.items || []).filter(item => Number(item.product_id) === Number(root.dataset.productId) || ids.has(String(item.variant_id || item.id)));
  }
  function bestDeal(root, cart) {
    const quantity = productLines(root, cart).reduce((total, item) => total + Number(item.quantity || 0), 0);
    return Array.from(root.querySelectorAll('[data-offer]')).filter(card => Number(card.dataset.quantity) <= quantity && (Number(card.dataset.discount) > 0 || normalizeCode(card.dataset.discountCode))).sort((a, b) => Number(b.dataset.quantity) - Number(a.dataset.quantity) || Number(b.dataset.discount) - Number(a.dataset.discount))[0] || null;
  }
  function discountVerified(root, cart, deal) {
    if (!deal) return true;
    const code = normalizeCode(deal.dataset.discountCode), percent = Number(deal.dataset.discount || 0);
    if (code) {
      const declared = (cart.discount_codes || []).find(entry => normalizeCode(entry.code) === code);
      if (declared && !declared.applicable) return false;
      if (!declared && !cartCodes(cart).includes(code)) return false;
    }
    const lines = productLines(root, cart);
    if (!lines.length || lines.some(item => typeof (item.final_line_price ?? item.line_price) !== 'number')) return false;
    const original = lines.reduce((total, item) => total + Number(item.original_line_price ?? Number(item.original_price ?? item.price ?? 0) * Number(item.quantity || 0)), 0);
    const final = lines.reduce((total, item) => total + Number(item.final_line_price ?? item.line_price ?? 0), 0);
    const tolerance = lines.reduce((total, item) => total + Number(item.quantity || 0), 0);
    if (original <= 0 || final >= original) return false;
    return !percent || final <= Math.round(original * (100 - percent) / 100) + tolerance;
  }
  async function readCart(root) {
    const response = await fetch(`${url(root)}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(root.dataset.cartError || 'Could not load your cart.');
    const cart = await response.json();
    if (!Array.isArray(cart.items) || typeof cart.total_price !== 'number') throw new Error(root.dataset.cartError || 'Could not load your cart.');
    return cart;
  }
  async function reconcileDiscount(root, cart, sections = []) {
    const deal = bestDeal(root, cart), code = normalizeCode(deal?.dataset.discountCode);
    const productId = root.dataset.productId;
    const relatedRoots = Array.from(document.querySelectorAll(selector)).filter(node => node.dataset.productId === productId);
    const managed = uniqueCodes(relatedRoots.flatMap(node => Array.from(node.querySelectorAll('[data-offer]')).map(card => card.dataset.discountCode)));
    const existing = cartCodes(cart), preserved = existing.filter(item => !managed.includes(item));
    const requested = uniqueCodes([...preserved, code]);
    const changed = existing.slice().sort().join(',') !== requested.slice().sort().join(',');
    let updatedCart = false;
    if (code || changed) {
      const payload = { discount: requested.join(',') };
      if (sections.length) { payload.sections = sections; payload.sections_url = location.pathname + location.search; }
      const response = await fetch(`${url(root)}cart/update.js`, { method: 'POST', headers, body: JSON.stringify(payload) });
      const updated = await response.json();
      if (!response.ok || updated.status) throw new Error(updated.description || updated.message || root.dataset.bundleError);
      if (!Array.isArray(updated.items) || typeof updated.total_price !== 'number') throw new Error(root.dataset.bundleError);
      cart = updated; updatedCart = true;
    }
    return { cart, deal, updatedCart, verified: discountVerified(root, cart, deal) };
  }
  function markDiscount(root, verified) {
    if (verified) { delete root.dataset.bundleWarning; pendingDiscounts.delete(root); }
    else root.dataset.bundleWarning = root.dataset.bundleError || 'Your items are in the cart, but the bundle discount could not be applied. Please retry or check the cart total before checkout.';
  }
  function querySafe(scope, value) {
    if (!value) return null;
    try { return scope.querySelector(value); } catch { return null; }
  }
  function themeDrawer(root) {
    const custom = querySafe(document, root.dataset.themeDrawerSelector);
    const node = custom || document.querySelector('cart-drawer,#CartDrawer,[data-cart-drawer],.cart-drawer');
    return node?.closest('cart-drawer') || node;
  }
  function drawerPlan(root, drawer) {
    const wrapper = drawer?.closest('[id^="shopify-section-"]');
    const wrapperId = wrapper?.id.replace(/^shopify-section-/, '');
    const owner = wrapperId && !/(?:^|__)main-cart(?:-|$)/i.test(wrapperId) ? wrapperId : 'cart-drawer';
    return { keys: Array.from(new Set([owner, 'cart-drawer', 'cart-icon-bubble'])), owner };
  }
  function drawerFragment(root, html, drawer) {
    if (typeof html !== 'string' || !html.trim()) return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const source = querySafe(doc, root.dataset.themeDrawerSelector) || doc.querySelector('cart-drawer') || (drawer?.id ? doc.getElementById(drawer.id) : null) || doc.getElementById('CartDrawer');
    if (!source || source.querySelector('#main-cart-items,#main-cart-footer,[data-main-cart-items]')) return null;
    if (!source.matches('cart-drawer,#CartDrawer,[data-cart-drawer]') && !source.querySelector('cart-drawer-items,#CartDrawer-Form,#CartDrawer-CartItems')) return null;
    return { source, doc, html: `<div id="shopify-section-cart-drawer" class="shopify-section">${source.outerHTML}</div>` };
  }
  async function freshShrineCart(root, drawer) {
    const plan = drawerPlan(root, drawer);
    let cart = null, sections = {};
    try {
      const response = await fetch(`${url(root)}cart/update.js`, { method: 'POST', headers, body: JSON.stringify({ updates: {}, sections: plan.keys, sections_url: location.pathname + location.search }) });
      const result = await response.json();
      if (response.ok && !result.status && Array.isArray(result.items)) { cart = result; sections = result.sections || {}; }
    } catch {}
    const keys = Array.from(new Set([plan.owner, 'cart-drawer']));
    let fragment = keys.map(key => drawerFragment(root, sections[key], drawer)).find(Boolean);
    if (!fragment) {
      try {
        const target = new URL(location.href); target.hash = ''; target.searchParams.delete('sections'); target.searchParams.delete('section_id'); target.searchParams.set('_svb_drawer', String(Date.now()));
        const response = await fetch(target, { headers: { Accept: 'text/html' }, cache: 'no-store' });
        if (response.ok) fragment = drawerFragment(root, await response.text(), drawer);
      } catch {}
    }
    if (!cart) cart = await readCart(root);
    return { cart, sections, fragment };
  }
  function patchShrineDrawer(root, drawer, fragment) {
    if (!drawer || !fragment) return false;
    const source = fragment.source;
    const currentPanel = querySafe(drawer, root.dataset.themeDrawerContent) || drawer.querySelector('.drawer__inner');
    const freshPanel = querySafe(source, root.dataset.themeDrawerContent) || source.querySelector('.drawer__inner');
    if (currentPanel && freshPanel) {
      currentPanel.innerHTML = freshPanel.innerHTML;
      currentPanel.classList.remove('is-empty');
      currentPanel.hidden = false;
    } else {
      const currentCart = drawer.id === 'CartDrawer' ? drawer : drawer.querySelector('#CartDrawer');
      const freshCart = source.id === 'CartDrawer' ? source : source.querySelector('#CartDrawer');
      if (!currentCart || !freshCart) return false;
      currentCart.innerHTML = freshCart.innerHTML;
    }
    drawer.classList.remove('is-empty'); drawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
    return true;
  }
  function updateShrineCounter(root, cart, sections, fragment) {
    const bubble = document.getElementById('cart-icon-bubble');
    let replacement = null;
    if (typeof sections['cart-icon-bubble'] === 'string') replacement = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').getElementById('cart-icon-bubble');
    if (!replacement) replacement = fragment?.doc.getElementById('cart-icon-bubble');
    if (bubble && replacement) bubble.innerHTML = replacement.innerHTML;
    document.querySelectorAll('[data-cart-count],#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]').forEach(node => { node.textContent = String(cart.item_count); });
  }
  async function openThemeDrawer(root, drawer) {
    const button = root.querySelector('[data-atc]');
    try { drawer?.setActiveElement?.(button); } catch {}
    if (typeof drawer?.open === 'function') { try { await drawer.open(button); return true; } catch {} }
    if (typeof drawer?.show === 'function') { try { await drawer.show(); return true; } catch {} }
    if (drawer instanceof HTMLDialogElement) { if (!drawer.open) drawer.showModal(); return true; }
    if (drawer instanceof HTMLDetailsElement) { drawer.open = true; return true; }
    const triggerSelectors = root.dataset.themeCartTrigger || '#cart-icon-bubble,[aria-controls="CartDrawer"],[data-cart-toggle],[data-cart-drawer-open]';
    let triggers = [];
    try { triggers = Array.from(document.querySelectorAll(triggerSelectors)); } catch {}
    const trigger = triggers.find(node => node !== button && !root.contains(node) && !drawer?.contains(node));
    if (trigger) {
      const preventNavigation = event => event.preventDefault();
      trigger.addEventListener('click', preventNavigation, { capture: true, once: true });
      trigger.click();
      trigger.removeEventListener('click', preventNavigation, { capture: true });
      return true;
    }
    return false;
  }
  async function refreshThemeDrawer(root) {
    const drawer = themeDrawer(root);
    if (!drawer) return false;
    const fresh = await freshShrineCart(root, drawer);
    if (!fresh.fragment) return false;
    const sections = { 'cart-drawer': fresh.fragment.html };
    const bubbleHTML = fresh.sections['cart-icon-bubble'];
    if (typeof bubbleHTML === 'string' && !new DOMParser().parseFromString(bubbleHTML, 'text/html').querySelector('#main-cart-items,#main-cart-footer,cart-drawer,#CartDrawer')) sections['cart-icon-bubble'] = bubbleHTML;
    let rendered = false;
    if (typeof drawer.renderContents === 'function' && sections['cart-icon-bubble']) {
      try {
        drawer.setActiveElement?.(root.querySelector('[data-atc]'));
        drawer.classList.remove('is-empty');
        await drawer.renderContents({ ...fresh.cart, id: picks(selected(root))[0]?.value, sections });
        rendered = true;
      } catch {}
    }
    if (!rendered) rendered = patchShrineDrawer(root, drawer, fresh.fragment);
    if (!rendered) return false;
    updateShrineCounter(root, fresh.cart, fresh.sections, fresh.fragment);
    return await openThemeDrawer(root, drawer);
  }
  function renderDiscountStatus(root) {
    const discountButton = root.querySelector('[data-retry-bundle-discount]'), cartButton = root.querySelector('[data-retry-theme-cart]');
    if (discountButton) { discountButton.hidden = !root.dataset.bundleWarning; discountButton.disabled = busy.has(root); }
    if (cartButton) { cartButton.hidden = !root.dataset.drawerWarning; cartButton.disabled = busy.has(root); }
  }
  function resultFeedback(root, fallback) {
    feedback(root, [root.dataset.bundleWarning, root.dataset.drawerWarning].filter(Boolean).join(' ') || fallback);
    renderDiscountStatus(root);
  }
  async function syncAndOpen(root, cart, signature, verified, seed = {}) {
    let ready = false;
    try { ready = await refreshThemeDrawer(root, cart, seed); } catch {}
    if (ready) delete root.dataset.drawerWarning;
    else root.dataset.drawerWarning = root.dataset.drawerError || 'Your items are in the cart, but your theme drawer could not be refreshed. Please try Refresh cart.';
    if (verified && ready) pendingDiscounts.delete(root);
    else pendingDiscounts.set(root, { signature });
    return ready;
  }
  async function retryDiscount(root, checkout = false) {
    if (busy.has(root)) return;
    const signature = pendingDiscounts.get(root)?.signature || selectionKey(selected(root));
    busy.add(root); refresh(root); renderDiscountStatus(root);
    let cart = null;
    try {
      const outcome = await reconcileDiscount(root, await readCart(root));
      cart = await readCart(root);
      const verified = discountVerified(root, cart, bestDeal(root, cart));
      markDiscount(root, verified);
      if (checkout && verified) { location.assign(`${url(root)}checkout`); return; }
      await syncAndOpen(root, cart, signature, verified, outcome.cart.sections || {});
      resultFeedback(root, verified ? root.dataset.bundleApplied || 'Bundle discount applied.' : '');
    } catch {
      root.dataset.bundleWarning = root.dataset.bundleError || 'The bundle discount could not be applied. Your items are already in the cart.';
      try { cart = await readCart(root); await syncAndOpen(root, cart, signature, false); } catch { root.dataset.drawerWarning = root.dataset.drawerError; }
      pendingDiscounts.set(root, { signature }); resultFeedback(root, '');
    } finally { busy.delete(root); refresh(root); renderDiscountStatus(root); }
  }
  async function add(root, checkout) {
    if (busy.has(root)) return;
    if (!root.dataset.originalAdd) boot();
    const card = selected(root), signature = selectionKey(card);
    if (!valid(card)) { feedback(root, root.dataset.soldOut || 'Please select an available variant.'); return; }
    if (pendingDiscounts.get(root)?.signature === signature) { await retryDiscount(root, checkout); return; }
    busy.add(root); refresh(root); feedback(root, ''); renderDiscountStatus(root);
    delete root.dataset.bundleWarning; delete root.dataset.drawerWarning;
    let added = false;
    try {
      const grouped = new Map();
      picks(card).forEach(option => grouped.set(option.value, (grouped.get(option.value) || 0) + 1));
      const items = Array.from(grouped, ([id, quantity]) => ({ id: Number(id), quantity }));
      const plan = drawerPlan(root, themeDrawer(root));
      const response = await fetch(`${url(root)}cart/add.js`, { method: 'POST', headers, body: JSON.stringify({ items, sections: plan.keys, sections_url: location.pathname + location.search }) });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || root.dataset.error || 'Could not add this selection.');
      added = true; pendingDiscounts.set(root, { signature });
      const outcome = await reconcileDiscount(root, await readCart(root), plan.keys);
      const cart = await readCart(root), verified = discountVerified(root, cart, bestDeal(root, cart));
      markDiscount(root, verified);
      if (checkout && verified) { location.assign(`${url(root)}checkout`); return; }
      await syncAndOpen(root, cart, signature, verified, outcome.updatedCart ? outcome.cart.sections : result.sections);
      resultFeedback(root, root.dataset.success || 'Added to your cart.');
    } catch (error) {
      if (added) {
        root.dataset.bundleWarning = root.dataset.bundleError || 'The bundle discount could not be applied. Your items are already in the cart.';
        try { const cart = await readCart(root); await syncAndOpen(root, cart, signature, false); } catch { root.dataset.drawerWarning = root.dataset.drawerError; }
        pendingDiscounts.set(root, { signature }); resultFeedback(root, '');
      } else feedback(root, error.message || root.dataset.error || 'Could not add this selection.');
    } finally { busy.delete(root); refresh(root); renderDiscountStatus(root); }
  }
  document.addEventListener('submit', event => {
    const root = rootOf(event.target);
    if (!root || !event.target.matches('.svb__form')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    add(root, event.submitter?.matches('[data-buy-now]'));
  }, true);
  document.addEventListener('change', event => {
    const root = rootOf(event.target); if (!root) return;
    if (event.target.matches('.svb__offer-heading>input,[data-variant-picker]')) {
      refresh(root); feedback(root, '');
      const id = event.target.selectedOptions?.[0]?.dataset.imageId;
      if (id) { const index = Array.from(root.querySelectorAll('[data-slide]')).findIndex(slide => slide.dataset.imageId === id); if (index >= 0) gallery(root, index); }
    }
  }, true);
  document.addEventListener('click', async event => {
    const root = rootOf(event.target); if (!root) return;
    const target = event.target;
    const thumb = target.closest('[data-thumb]');
    if (thumb) { event.preventDefault(); gallery(root, Number(thumb.dataset.thumb)); }
    if (target.closest('[data-prev]')) gallery(root, Number(root.dataset.galleryIndex || 0) - 1);
    if (target.closest('[data-next]')) gallery(root, Number(root.dataset.galleryIndex || 0) + 1);
    if (target.closest('[data-sticky-atc]')) { event.preventDefault(); add(root, false); }
    const close = target.closest('[data-close]'); if (close) close.closest('dialog')?.close();
    if (target.closest('[data-size-guide]')) root.querySelector('[data-size-dialog]')?.showModal();
    if (target.closest('[data-retry-bundle-discount],[data-retry-theme-cart]')) { event.preventDefault(); await retryDiscount(root); }
    if (target.closest('[data-zoom]')) {
      const slide = root.querySelectorAll('[data-slide]')[Number(root.dataset.galleryIndex || 0)];
      const image = slide?.querySelector('img'); const dialog = root.querySelector('[data-lightbox]');
      if (image && dialog) { dialog.querySelector('[data-zoom-content]').replaceChildren(image.cloneNode()); dialog.showModal(); }
    }
    const copy = target.closest('[data-copy-code]');
    if (copy) {
      try { await navigator.clipboard.writeText(copy.dataset.copyCode); copy.querySelector('[data-copy-label]').textContent = copy.dataset.copied || 'Copied ✓'; }
      catch { feedback(root, `${copy.dataset.fallback || 'Copy this code:'} ${copy.dataset.copyCode}`); }
    }
    if (target.matches('dialog')) { const box=target.getBoundingClientRect(); if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)target.close(); }
  }, true);
  let touch = null;
  document.addEventListener('touchstart', event => { const root=rootOf(event.target); if(root && event.target.closest('[data-slides]')) touch={root,x:event.changedTouches[0].clientX,y:event.changedTouches[0].clientY}; }, {passive:true});
  document.addEventListener('touchend', event => { if(!touch)return;const dx=event.changedTouches[0].clientX-touch.x,dy=event.changedTouches[0].clientY-touch.y;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy))gallery(touch.root,Number(touch.root.dataset.galleryIndex||0)+(dx<0?1:-1));touch=null; }, {passive:true});
  let frame;
  window.addEventListener('scroll', () => { if(frame)return;frame=requestAnimationFrame(()=>{frame=null;document.querySelectorAll(selector).forEach(root=>{const bar=root.querySelector('[data-sticky-bar]'),button=root.querySelector('[data-atc]');if(bar&&button)bar.hidden=button.getBoundingClientRect().bottom>=0||root.dataset.sticky!=='true';});}); }, {passive:true});
  window.__salvationEnglish13 = boot;
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  document.addEventListener('shopify:section:load', boot);
})();

(() => {
  if (window.__salvationBundleSwatches4) { window.__salvationBundleSwatches4(); return; }
  const rowStates = new WeakMap();
  const rootSelector = '[data-salvation-v13]';
  const rootOf = target => target instanceof Element ? target.closest(rootSelector) : null;
  function sync(row) {
    const state = rowStates.get(row);
    if (!state) return;
    const current = state.variants.find(variant => variant.node.value === state.native.value);
    if (!current) return;
    const soldOut = rootOf(row)?.dataset.soldOut || 'Sold out';
    row.querySelectorAll('[data-bundle-swatch]').forEach(button => {
      const index = Number(button.dataset.optionIndex), value = button.dataset.value;
      const available = state.variants.some(variant => variant.available && variant.values[index] === value);
      button.disabled = !available;
      button.setAttribute('aria-disabled', String(!available));
      button.setAttribute('aria-pressed', String(current.values[index] === value));
      button.title = `${button.dataset.colorLabel}${available ? '' : ` — ${soldOut}`}`;
      button.setAttribute('aria-label', button.title);
    });
    row.querySelectorAll('[data-bundle-option]').forEach(select => {
      const index = Number(select.dataset.optionIndex);
      Array.from(select.options).forEach(option => {
        const available = state.variants.some(variant => variant.available && variant.values[index] === option.value && current.values.every((value, position) => position === index || variant.values[position] === value));
        option.disabled = !available;
        option.textContent = `${option.dataset.baseLabel}${available ? '' : ` — ${soldOut}`}`;
      });
      select.value = current.values[index];
    });
    const caption = row.querySelector('[data-bundle-color-name]');
    if (caption) caption.textContent = row.querySelector('[data-bundle-swatch][aria-pressed="true"]')?.dataset.colorLabel || '';
  }
  function choose(row, index, value) {
    const state = rowStates.get(row);
    if (!state) return;
    const current = state.variants.find(variant => variant.node.value === state.native.value);
    if (!current) return;
    const wanted = current.values.map((item, position) => position === index ? value : item);
    let next = state.variants.find(variant => variant.available && wanted.every((item, position) => variant.values[position] === item));
    if (!next) {
      const isColour = Array.from(row.querySelectorAll('[data-bundle-swatch]')).some(button => Number(button.dataset.optionIndex) === index);
      if (isColour) {
        let score = -1;
        state.variants.forEach(variant => {
          if (!variant.available || variant.values[index] !== value) return;
          const matches = wanted.reduce((total, item, position) => total + Number(position !== index && variant.values[position] === item), 0);
          if (matches > score) { next = variant; score = matches; }
        });
      }
    }
    if (!next) { sync(row); return; }
    state.native.value = next.node.value;
    sync(row);
    state.native.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function boot() {
    document.querySelectorAll(`${rootSelector} [data-bundle-options]`).forEach(controls => {
      const row = controls.closest('.svb__item');
      if (rowStates.has(row)) { sync(row); return; }
      const native = row.querySelector('[data-variant-picker]');
      if (!native) return;
      let variants;
      try { variants = Array.from(native.options).map(node => ({ node, values: JSON.parse(node.dataset.options), available: !node.disabled })); }
      catch { return; }
      const count = Number(controls.dataset.optionCount);
      if (!count || !variants.length || variants.some(variant => !Array.isArray(variant.values) || variant.values.length !== count)) return;
      rowStates.set(row, { native, variants });
      sync(row);
      controls.hidden = false;
      row.dataset.swatchReady = 'true';
    });
  }
  document.addEventListener('click', event => {
    const root = rootOf(event.target);
    if (!root) return;
    const button = event.target.closest('[data-bundle-swatch]');
    if (!button || button.matches(':disabled')) return;
    event.preventDefault();
    choose(button.closest('.svb__item'), Number(button.dataset.optionIndex), button.dataset.value);
  });
  document.addEventListener('change', event => {
    if (!rootOf(event.target)) return;
    const target = event.target;
    if (target.matches('[data-bundle-option]')) choose(target.closest('.svb__item'), Number(target.dataset.optionIndex), target.value);
    if (target.matches('[data-variant-picker]')) sync(target.closest('.svb__item'));
  });
  window.__salvationBundleSwatches4 = boot;
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  document.addEventListener('shopify:section:load', boot);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__littleReindeerSticky1) { window.__littleReindeerSticky1(); return; }
  const roots = new Map();
  const mobile = matchMedia('(max-width: 749px)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const sourceDefault = '[data-salvation-root][data-salvation-v13]';
  const overlaySelector = 'cart-drawer,#CartDrawer,.cart-drawer,dialog,[role="dialog"],.menu-drawer,.search-modal';
  const query = (selector, parent = document) => { try { return selector ? parent.querySelector(selector) : null; } catch { return null; } };
  const put = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const attr = (node, name, value) => { if (node && node.getAttribute(name) !== String(value)) node.setAttribute(name, String(value)); };
  const conceal = (node, value) => { if (node && node.hidden !== value) node.hidden = value; };
  const text = node => node?.textContent.trim() || '';
  const shown = element => {
    if (!element?.isConnected || element.hidden) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && element.getClientRects().length > 0;
  };
  function findSource(entry) {
    const custom = query(entry.root.dataset.sourceSelector.trim());
    if (entry.root.dataset.sourceSelector.trim()) return custom?.matches(sourceDefault) ? custom : query(sourceDefault, custom || document.createElement('div'));
    return query(sourceDefault);
  }
  function overlayOpen() {
    return Array.from(document.querySelectorAll(overlaySelector)).some(node => {
      if (node.closest('.lrstick')) return false;
      if (node.matches('dialog')) return node.open && shown(node);
      if (node.getAttribute('aria-hidden') === 'true') return false;
      const signalled = node.classList.contains('active') || node.classList.contains('is-open') || node.classList.contains('open') || node.classList.contains('menu-opening') || node.hasAttribute('open') || node.getAttribute('aria-hidden') === 'false' || node.getAttribute('aria-modal') === 'true';
      if (!signalled) return false;
      return shown(node) && node.getBoundingClientRect().right > 0 && node.getBoundingClientRect().left < innerWidth;
    });
  }
  function setVisible(entry, visible) {
    attr(entry.bar, 'data-visible', visible);
    attr(entry.bar, 'aria-hidden', !visible);
    if (entry.bar.inert === visible) entry.bar.inert = !visible;
  }
  function claim(entry, source) {
    if (entry.source === source) return;
    entry.observer?.disconnect();
    entry.resize?.disconnect();
    release(entry);
    entry.source = source;
    if (!source) return;
    if (entry.root.dataset.hideOld === 'true') attr(source, 'data-lr-sticky-owned', entry.root.dataset.sectionId);
    entry.observer = new MutationObserver(() => schedule());
    entry.observer.observe(source, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled','aria-busy','data-ready','data-selected','hidden','src','srcset','value']});
    entry.resize = new ResizeObserver(() => schedule());
    entry.resize.observe(source);
  }
  function release(entry) {
    if (entry.source?.getAttribute('data-lr-sticky-owned') === entry.root.dataset.sectionId) entry.source.removeAttribute('data-lr-sticky-owned');
  }
  function image(entry, card) {
    if (entry.root.dataset.automaticImage !== 'true') return;
    const wrap = query('[data-lr-sticky-image-wrap]', entry.bar), photo = query('img', wrap || entry.bar);
    if (!wrap || !photo) return;
    const variant = query('[data-variant-picker]', card || entry.source)?.selectedOptions?.[0];
    const imageId = variant?.dataset.imageId;
    const slides = Array.from(entry.source.querySelectorAll('[data-slide]'));
    const slide = slides.find(node => imageId && node.dataset.imageId === imageId) || slides.find(node => !node.hidden) || slides[0];
    const original = query('img', slide || entry.source);
    const src = original?.currentSrc || original?.getAttribute('src');
    if (!src) return;
    if (photo.getAttribute('src') !== src) {
      photo.removeAttribute('srcset');
      photo.removeAttribute('sizes');
      photo.src = src;
    }
    conceal(photo, false); conceal(wrap, false);
  }
  function sync(entry) {
    const source = entry.source, bar = entry.bar;
    if (!source) { setVisible(entry, false); entry.spacer.style.height = '0px'; return; }
    const button = query('[data-atc]', source);
    const ready = source.hasAttribute('data-ready') && !!button;
    const card = query('[data-offer][data-selected="true"]', source) || query('[data-offer]:has(input[type="radio"]:checked)', source);
    const sourceLabel = text(query('[data-atc-label]', source));
    const busy = ready && button.disabled && (sourceLabel === source.dataset.adding || button.getAttribute('aria-busy') === 'true');
    if (!button?.disabled) entry.pending = false;
    const loading = busy || entry.pending;
    const ownButton = query('[data-lr-sticky-add]', bar);
    const disabled = !ready || button.disabled || loading;
    if (ownButton.disabled !== disabled) ownButton.disabled = disabled;
    attr(ownButton, 'aria-busy', loading);
    let label = loading ? entry.root.dataset.loadingLabel : ready && button.disabled ? entry.root.dataset.soldoutLabel : mobile.matches && entry.root.dataset.mobileLabel ? entry.root.dataset.mobileLabel : entry.root.dataset.addLabel;
    put(query('[data-lr-sticky-button-label]', bar), label);
    attr(ownButton, 'aria-label', label);
    if (entry.root.dataset.automaticTitle === 'true') {
      const heading = query('.svb__title', source);
      const title = heading ? Array.from(heading.childNodes).filter(node => node.nodeType === Node.TEXT_NODE).map(node => node.textContent).join('').trim() || text(heading) : '';
      if (title) put(query('[data-lr-sticky-title]', bar), title);
    }
    const price = text(query('[data-atc-price]', source)) || text(query('[data-main-price]', source));
    const sourceCompare = query('[data-main-compare]', source);
    const compare = sourceCompare && !sourceCompare.hidden ? text(sourceCompare) : '';
    const priceNode = query('[data-lr-sticky-price]', bar);
    if (priceNode) {
      put(priceNode, price);
      const compareNode = query('[data-lr-sticky-compare]', bar);
      put(compareNode, compare); conceal(compareNode, !compare);
      const mobilePrice = query('[data-lr-sticky-mobile-price]', bar);
      if (mobilePrice.dataset.value !== price + '|' + compare) {
        mobilePrice.replaceChildren(document.createTextNode(price));
        if (compare) { const strike = document.createElement('s'); strike.textContent = compare; mobilePrice.append(strike); }
        mobilePrice.dataset.value = price + '|' + compare;
      }
    }
    const selection = query('[data-lr-sticky-selection]', bar);
    if (selection) {
      const title = text(query('.svb__offer-copy strong', card || source));
      const variants = Array.from(card?.querySelectorAll('[data-variant-picker]') || []).map(select => text(select.selectedOptions[0]));
      const summary = title ? title + (variants.length === 1 ? ' · ' + variants[0] : '') : text(query('[data-selection-summary]', source));
      if (summary) { put(selection, summary); attr(selection, 'title', summary); }
    }
    image(entry, card);
    const feedback = query('[data-feedback]', source);
    const feedbackText = feedback && !feedback.hidden && !loading ? text(feedback) : '';
    if (entry.submitted) { put(query('[data-lr-sticky-status]', bar), feedbackText); conceal(query('[data-lr-sticky-status]', bar), !feedbackText); }
    const customTrigger = entry.root.dataset.triggerSelector.trim();
    const trigger = customTrigger ? query(customTrigger) : source;
    const passed = !!trigger && trigger.getBoundingClientRect().bottom <= -Number(entry.root.dataset.triggerOffset || 0);
    if (!passed) entry.dismissed = false;
    const onDevice = entry.root.dataset.devices === 'both' || (mobile.matches ? entry.root.dataset.devices === 'mobile' : entry.root.dataset.devices === 'desktop');
    const preview = entry.root.dataset.designMode === 'true' && entry.root.dataset.preview === 'true';
    const eligible = ready && shown(source) && onDevice && (passed || preview) && !entry.dismissed;
    const blocked = entry.root.dataset.hideOverlays === 'true' && overlayOpen();
    if (blocked && entry.submitted) {
      const drawer = query('cart-drawer.active,cart-drawer.is-open,cart-drawer[open]');
      drawer?.setActiveElement?.(ownButton);
    }
    const keyboard = mobile.matches && window.visualViewport && window.visualViewport.height < document.documentElement.clientHeight * .7 && document.activeElement?.matches('input,textarea,[contenteditable="true"]');
    setVisible(entry, !!(eligible && !blocked && !keyboard));
    const reserve = entry.root.dataset.reserve === 'true' && eligible && !preview;
    const height = reserve ? Math.ceil(bar.getBoundingClientRect().height + Number(mobile.matches ? getComputedStyle(bar).getPropertyValue('--ls-bottom-m').replace('px','') : getComputedStyle(bar).getPropertyValue('--ls-bottom').replace('px','')) + 16) : 0;
    if (entry.spacer.style.height !== height + 'px') entry.spacer.style.height = height + 'px';
  }
  let frame = 0;
  function schedule() {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      roots.forEach(entry => {
        if (!entry.root.isConnected) { destroy(entry); return; }
        claim(entry, findSource(entry));
        sync(entry);
      });
    });
  }
  function scrollBack(entry) {
    const target = query('.svb__offers', entry.source) || query('[data-atc]', entry.source) || entry.source;
    if (!target) return;
    const top = Math.max(0, scrollY + target.getBoundingClientRect().top - 100);
    window.scrollTo({top, behavior:reduced.matches ? 'instant' : 'smooth'});
    const control = Array.from(entry.source.querySelectorAll('[data-offer][data-selected="true"] [data-bundle-option], [data-offer][data-selected="true"] [data-variant-picker], [data-atc]')).find(node => shown(node) && !node.disabled);
    if (control && !control.disabled) control.focus({preventScroll:true});
  }
  function boot() {
    document.querySelectorAll('[data-lr-sticky-root]').forEach(root => {
      if (roots.has(root)) return;
      const bar = query('[data-lr-sticky-bar]', root);
      if (!bar) return;
      const entry = {root,bar,source:null,dismissed:false,pending:false,submitted:false};
      entry.spacer = document.createElement('div'); entry.spacer.className = 'lrstick__spacer'; entry.spacer.setAttribute('aria-hidden','true');
      document.body.append(bar, entry.spacer);
      roots.set(root, entry);
      bar.addEventListener('click', event => {
        const edit = event.target.closest('[data-lr-sticky-edit]');
        if (edit) { event.preventDefault(); scrollBack(entry); return; }
        if (event.target.closest('[data-lr-sticky-close]')) { entry.dismissed = true; schedule(); return; }
        if (!event.target.closest('[data-lr-sticky-add]')) return;
        event.preventDefault();
        const sourceButton = query('[data-atc]', entry.source || document.createElement('div'));
        if (entry.pending || !sourceButton || sourceButton.disabled || !entry.source.hasAttribute('data-ready')) return;
        entry.pending = true; entry.submitted = true;
        const ownButton = query('[data-lr-sticky-add]', bar);
        ownButton.disabled = true; attr(ownButton, 'aria-busy', true);
        try { sourceButton.click(); }
        catch {
          entry.pending = false;
          put(query('[data-lr-sticky-status]', bar), root.dataset.errorLabel);
          conceal(query('[data-lr-sticky-status]', bar), false);
        }
        schedule();
      });
      entry.barResize = new ResizeObserver(() => schedule()); entry.barResize.observe(bar);
    });
    schedule();
  }
  function destroy(entry) {
    entry.observer?.disconnect(); entry.resize?.disconnect(); entry.barResize?.disconnect();
    release(entry); entry.bar.remove(); entry.spacer.remove(); roots.delete(entry.root);
  }
  window.__littleReindeerSticky1 = boot;
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', event => {
    roots.forEach(entry => { if (event.target.contains(entry.root)) destroy(entry); });
    schedule();
  });
  document.addEventListener('shopify:section:select', schedule);
  document.addEventListener('change', schedule, true);
  document.addEventListener('close', schedule, true);
  document.addEventListener('toggle', schedule, true);
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  window.addEventListener('pageshow', schedule);
  mobile.addEventListener('change', schedule);
  window.visualViewport?.addEventListener('resize', schedule, {passive:true});
  const observer = new MutationObserver(records => {
    if (records.every(record => record.target instanceof Element && (record.target.closest('.lrstick') || record.target.closest('.lrstick__spacer')))) return;
    if (Array.from(document.querySelectorAll('[data-lr-sticky-root]')).some(root => !roots.has(root))) boot();
    else schedule();
  });
  observer.observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['class','open','aria-hidden','aria-modal','hidden','style']});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
})();


  } catch(e) { console.error(e); }
})();
})();
